import { HumanResourceService } from './../../services/human-resource.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfileCommon } from './profile.common';
import { NgbDate, NgbDateStruct, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { AppPattern } from 'src/app/services/app-pattern';
import * as moment from 'moment';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MatOption } from '@angular/material/core';
import * as _ from 'lodash';
import { ElementRef } from '@angular/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
// import { boolean } from 'joi';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MatSelectChange } from '@angular/material/select';
import { state } from '@angular/animations';
import { Console } from 'console';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  // employeeForm:FormGroup
  appPattern = new AppPattern();
  title = "Manage Profile"
  empType = 'Employee';
  modalStatus = '';
  closeResult = '';
  verficationDoneList = [{ id: '1', name: 'Yes', value: true }, { id: '2', name: 'No', value: false }];
  articleTypeList = [{ id: 1, name: 'PGB(Normal)' }, { id: 2, name: 'Transfer' }, { id: 3, name: 'Secondment' }, { id: 4, name: 'Temporary' }, { id: 5, name: 'Intern' }];
  employeeTypeList = [{ id: 1, name: 'Article' }, { id: 2, name: 'Consultant' }, { id: 3, name: 'Employee' }];
  bankAccountList = [{ id: 1, name: 'ICICI' }, { id: 2, name: 'Other Bank' }];
  monthList = [{ "no": 1, "abbreviation": "Jan", "name": "January" }, { "no": 2, "abbreviation": "Feb", "name": "February" }, { "no": 3, "abbreviation": "Mar", "name": "March" }, { "no": 4, "abbreviation": "Apr", "name": "April" }, { "no": 5, "abbreviation": "May", "name": "May" }, { "no": 6, "abbreviation": "Jun", "name": "June" }, { "no": 7, "abbreviation": "Jul", "name": "July" }, { "no": 8, "abbreviation": "Aug", "name": "August" }, { "no": 9, "abbreviation": "Sep", "name": "September" }, { "no": 10, "abbreviation": "Oct", "name": "October" }, { "no": 11, "abbreviation": "Nov", "name": "November" }, { "no": 12, "abbreviation": "Dec", "name": "December" }]
  employeeForm;
  employeeFormList = [];
  employeeFormSubmitted = false;
  employeeFormErrors = ProfileCommon.employeeFormErrors;
  employeeFormValidationMessages = ProfileCommon.employeeFormValidationMessages;

  role;
  roleList: any;
  branchList: any;
  designationList: any;
  reportingPartnerList: any;
  registerPartnerList: any;
  partnerList: any;
  reportingManagerList: any;
  clientList: any;
  certificationList: any;
  qualificationList: any;
  serviceVerticalList: any;
  overtimeApplicabilityList: any;

  stateList: any;
  localCityList: any;
  localPostcodeList: any;
  permanentCityList: any;
  permanentPostcodeList: any;
  oldLocalAddress: any;

  showPermanentCity = false;
  showPermanentPostCode = false;
  showLocalCity = false;
  showLocalPostCode = false;

  query;
  limit = 10;
  page = 0
  fileList: FileList;
  formData: FormData;
  exitDateValidation;
  userType;
  hideChooseFile = false;
  articleshipTenureResponse;
  menuList: any;
  allowedComponents = new Set<string>();
  allowedsubmenuComponents = new Set<string>();
  profileStatus: boolean | null = null;

  //  formObj: any;
  @ViewChild('modalContent') private modalContent;
  designation: string;
  //  @ViewChild('otherSelected') private otherSelected: MatOption;
  constructor(private modalService: NgbModal, private fb: FormBuilder, private humanResourceService: HumanResourceService, private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService) {

  }

  // Pagination
  oldEmployeeFormList;
  // searchProfilesByName() {
  //   console.log('query value', this.query);
  //   this.humanResourceService.getProfileByName(this.query)
  //     .subscribe((res: any) => {
  //       this.employeeFormList = res;
  //       // var oldList = [...this.employeeFormList];
  //       // var newList = [...res];
  //       // var ids = new Set(oldList.map(d => d.id));
  //       // console.log('ids value in search bar',ids);
  //       // this.employeeFormList = [...oldList, ...newList.filter(d => !ids.has(d.id))];
  //       // console.log('employee list',this.employeeFormList);
  //       // [...oldList.concat(newList)];
  //     });
  // }


  activeSelected = false;
  closedSelected = false;

  searchProfilesByName() {
    console.log('query value', this.query);

    let profileStatus: boolean | null = null;

    if (this.activeSelected && !this.closedSelected) {
      profileStatus = true;
    } else if (!this.activeSelected && this.closedSelected) {
      profileStatus = false;
    }

    this.humanResourceService
      .getProfileByName(this.query, profileStatus)
      .subscribe((res: any) => {
        this.employeeFormList = res;
      });
  }

  searchNameClick() {
    if (this.query == "") {
      console.log('inside query empty');
      this.loadProfiles();
    }
  }

  loadPreviousUsers() {
    if (this.page > 0) {
      this.page = this.page - 1;
      this.humanResourceService.getProfile(this.page, this.limit)
        .subscribe((res: any) => {
          console.log('grtprofile', res);
          this.employeeFormList = res;
          window.scroll(0, 0);
        });
    }
  }

  loadNextUsers() {
    this.page = this.page + 1;
    this.humanResourceService.getProfile(this.page, this.limit)
      .subscribe((res: any) => {
        this.employeeFormList = res;
        window.scroll(0, 0);
      });
  }

  openModal(status) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xxl',
      windowClass: "animate__animated animate__slideInUp animate__faster",
      backdrop: 'static',
      keyboard: false
    }
    this.modalStatus = status;
    this.modalService.open(this.modalContent, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed`;
    });
  }

  closeModal() {
    console.log("in close modal");
    this.myFiles = [];
    this.resetEmployeeForm();
    this.modalService.dismissAll();
  }

  ngOnInit() {

    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
      menu.menu?.menuComponents?.forEach(component => {
        this.allowedComponents.add(component.name);
      });

      menu.menu.submenus?.forEach(submenu => {
        submenu.subMenuComponents?.forEach(submenuComponent => {
          this.allowedsubmenuComponents.add(submenuComponent.name);
        });
      });
    });

    // Usage
    const exitDateMax = this.getFinancialYearEndDate();
    console.log('Financial Year End Date:', exitDateMax);

    this.exitDateValidation = {
      year: exitDateMax.getFullYear(),
      month: exitDateMax.getMonth() + 1,
      day: exitDateMax.getDate()
    };


    console.log('current date for check', this.exitDateValidation);
    this.userType = localStorage.getItem('userType');
    console.log('user type', this.userType);
    this.loadLookupOfQualificationAndServicevertical();
    this.initEmployeeForm();
    this.loadProfiles();
    this.employeeForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.employeeForm);
    });
    if (this.empType === 'Employee' || this.empType === 'Consultant') {
      this.employeeForm.get('serviceVerticle').setValidators(Validators.required);
      this.employeeForm.get('serviceVerticle').updateValueAndValidity();
      this.employeeForm.get('qualification').clearValidators();
      this.employeeForm.get('qualification').updateValueAndValidity();
      this.employeeForm.get('userQualifications').setValidators(Validators.required);
      this.employeeForm.get('userQualifications').updateValueAndValidity();

    } else {
      this.employeeForm.get('serviceVerticle').clearValidators();
      this.employeeForm.get('serviceVerticle').updateValueAndValidity();
      this.employeeForm.get('userQualifications').clearValidators();
      this.employeeForm.get('userQualifications').updateValueAndValidity();
      this.employeeForm.get('qualification').setValidators(Validators.required);
      this.employeeForm.get('qualification').updateValueAndValidity();

    }

    this.employeeForm.get('permanentAddress.address')?.valueChanges.subscribe(() => {
      this.uncheckAddressCheckbox();
    });
    this.employeeForm.get('permanentAddress.streetName')?.valueChanges.subscribe(() => {
      this.uncheckAddressCheckbox();
    });
    this.employeeForm.get('permanentAddress.country')?.valueChanges.subscribe(() => {
      this.uncheckAddressCheckbox();
    });

    this.employeeForm.controls['localAddress']?.enable();

    this.role = localStorage.getItem('droles');

    if (this.empType === 'Employee' && ['Partner', 'Managing Partner', 'Designated Partner'].includes(this.role)) {
      this.employeeForm.get('reportingManager').clearValidators();
      this.employeeForm.get('reportingManager').updateValueAndValidity();
    }

    this.onQualificationsChange();

    this.initCtcDetails();
    this.initializeCtcFormChangeSubscription();
    this.listenToCtcChangesForPfApplicable();
    // this.listenToCtcInput();


  }

  hasAccess(componentName: string): boolean {
    return this.allowedsubmenuComponents.has(componentName);
  }


  calculateLoanToDate(date: any) {
    const jsDate = new Date(date.year, date.month - 1, date.day);

    jsDate.setFullYear(jsDate.getFullYear() + 2);
    jsDate.setDate(jsDate.getDate() - 1);

    return {
      year: jsDate.getFullYear(),
      month: jsDate.getMonth() + 1,
      day: jsDate.getDate()
    };
  }

  calculateSecurityToDate(date: any) {
    const jsDate = new Date(date.year, date.month - 1, date.day);

    jsDate.setMonth(jsDate.getMonth() + 6);

    jsDate.setDate(jsDate.getDate() - 1);

    return {
      year: jsDate.getFullYear(),
      month: jsDate.getMonth() + 1,
      day: jsDate.getDate()
    };
  }

  compareItems(i1, i2) {
    return i1 && i2 && i1.id === i2.id;
  }

  getFinancialYearEndDate() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    // Financial year ends on March 31st of the next year if it's after March, otherwise it ends this year
    const financialYearEndYear = currentMonth <= 3 ? currentYear : currentYear + 1;

    return new Date(`${financialYearEndYear}-03-31`);
  }


  showDescription = false;
  checkSelection() {
    console.log('certificate value', this.employeeForm.value.certificationType);
    var index = -1
    index = this.employeeForm.value.certificationType.findIndex(item => item.name === 'Others')
    console.log("certification Index", index)
    if (index >= 0) {
      this.showDescription = true;
      this.employeeForm.get('description').setValidators(Validators.required);
      var index1 = this.certificationList.findIndex(item => item.name === this.employeeForm.value.certificationType[index].name)
      // this.employeeForm.controls.certificationType.patchValue([{ id: 8, name: "Others" }]);
      this.employeeForm.controls.certificationType.patchValue([this.certificationList[index1]]);
    } else {
      this.showDescription = false;
      this.employeeForm.get('description').clearValidators();
    }
    this.employeeForm.get('description').updateValueAndValidity();
    console.log('certificate value', this.employeeForm.value.certificationType);
  }


  initEmployeeForm() {


    this.employeeForm = this.fb.group({
      id: [],
      userId: [],
      firstName: ['', [Validators.required, Validators.maxLength(50)]],
      middleName: [''],
      lastName: ['', [Validators.required, Validators.maxLength(50)]],
      //  password:  ['',Validators.required],
      // Personal Details
      email: ['', [Validators.required]],
      dateOfBirth: ['', [Validators.required]],
      bloodGroup: ['', [Validators.required]],
      panNumber: ['', [Validators.required, Validators.pattern(this.appPattern.PAN_PATTERN)]],
      aadharNumber: ['', [Validators.required, Validators.pattern(this.appPattern.AADHAR_PATTERN)]],
      qualification: ['', [Validators.required]],
      userQualifications: ['', [Validators.required]],
      certificationType: [null, [Validators.required]],
      description: ['', []],
      gender: ['', []],
      profileStatus: [true, [Validators.required]],
      personalEmail: ['', [Validators.required]],
      officalMobileNumber: [null, [Validators.required]],
      contactMobileNumber: ['', [Validators.required]],
      //  landlineStdCode:['', [Validators.required]],
      //  landlineNumber:['', [Validators.required]],
      emergencyContactNumber1: ['', [Validators.required]],
      emergencyContactName1: ['', [Validators.required]],
      emergencyContactRelation1: ['', [Validators.required]],
      emergencyContactNumber2: ['', [Validators.required]],
      emergencyContactName2: ['', [Validators.required]],
      emergencyContactRelation2: ['', [Validators.required]],
      //  Personal Contact Details
      permanentAddress: this.fb.group({
        address: ['', [Validators.required]],
        city: [null, [Validators.required]],
        state: [null, [Validators.required]],
        postalCode: [null, [Validators.required]],
        country: ['', [Validators.required]],
        streetName: [''],
        type: 'permanent',
      }),
      sameAsPermanent: [false],
      localAddress: this.fb.group({
        address: ['', [Validators.required]],
        city: [null, [Validators.required]],
        state: [null, [Validators.required]],
        postalCode: [null, [Validators.required]],
        country: ['', [Validators.required]],
        streetName: [''],
        type: 'local',
      }),
      // Official Details
      branch: [null, [Validators.required]], //*
      droles: ['', Validators.required],
      designation: [null, Validators.required],

      reportingManager: ['', [Validators.required]],//*
      //reportingManager: [null],
      //reportingPartner: [null],//*
      reportingPartners: this.fb.array([this.addPartnerFormGroup()]),
      //reportingPartners: this.fb.array([null]),

      joiningDate: ['', [Validators.required]],
      membershipNumber: [{ value: '', disabled: true }, Validators.required],
      dateOfMembershipNumber: ['', Validators.required],
      probabtionPeriod: ['', Validators.required],
      //  articleTrainingLimit:['',Validators.required],
      verified: [''],
      confirmationDate: [null, Validators.required],
      verificationSource: [''],
      remark: [''],
      laptopServiceTagNumber: ['', [Validators.required]],
      scholarship: [''],
      serviceVerticle: [''],
      //  dataCardNumber:['', [Validators.required]],
      bankAcountName: ['', [Validators.required]],
      newBankAcountName: [''],
      bankAccountNumber: ['', [Validators.required]],
      bankIfscCode: [''],
      articleType: [null],
      icaiRegistrationDate: [''],
      icaiRegistrationNumber: [''],
      articleshipEndDate: [''],
      registeredPartner: [null],
      clients: [''],
      commitmentDate: ['', [Validators.required]],

      // CTC Details
      // userCtcDetails: this.fb.array([], [Validators.required]),
      userCtcDetails: this.fb.array([]),
      //userCtcDetails: this.fb.array([], this.empType === 'Article' ? [] : [Validators.required]),
      // Exit Details
      userExitDetails: this.fb.group({
        dataCard: [''],
        exitDate: [null],
        exitForm: [''],
        exitReason: [''],
        idCard: [''],
        laptop: [''],
        officialDocument: [''],
        otherHardware: [''],
        penDrvie: [''],
        remark: [''],
      }),
      //  basic:['', [Validators.required]],
      //  hra:['', [Validators.required]],
      //  otherAllowance:['', [Validators.required]],
      //  conveyanceAllowance:['', [Validators.required]],
      //  medicalAllowance:['', [Validators.required]],
      //  educationAllowance:['', [Validators.required]],
      //  childHostelAllowance:['', [Validators.required]],
      //  fromDate:['', [Validators.required]],
      //  toDate:['', [Validators.required]],
    });

    this.setCtcValidators();
    this.initCtcDetails();

    //this.addPartnerButtonClick();
  }
  // ADD Partner
  addPartnerButtonClick() {
    (<FormArray>this.employeeForm.get('reportingPartners')).push(this.addPartnerFormGroup());
    //     var entryDate1 =this.employeeForm.controls['joiningDate'].value
    //  var entryDate2 = new Date(
    //   this.entryDate1.year +
    //     '-' +
    //     this.entryDate1.month +
    //     '-' +
    //     this.entryDate1.day
    // );
    // console.log('entrydate', entryDate2);
    // var formatDate = moment(entryDate2).format('YYYY-MM-DD');
    //  console.log('format date', formatDate);
    // console.log('Employee form in partner case',this.employeeForm.controls['joiningDate'].value);
    // console.log('inside partner',  this.employeeForm.get('reportingPartners').get('startDate'));
  }

  setFromDateOfPartner() {
    if (this.modalStatus == 'add') {
      ((this.employeeForm.get('reportingPartners') as FormArray).at(0) as FormGroup).get('startDate')
        .patchValue(this.employeeForm.controls['joiningDate'].value);

      var minDate1 = new Date(this.employeeForm.value.reportingPartners[0].startDate.year + "-12-31")
      var minDate2 = moment(minDate1, 'MM/DD/YYYY');
      var minDate3 = { year: parseInt(minDate2.format('YYYY')), month: parseInt(minDate2.format('M')), day: parseInt(minDate2.format('D')) };

      ((this.employeeForm.get('reportingPartners') as FormArray).at(0) as FormGroup).get('endDate')
        .patchValue(minDate3);
    }
  }

  setCtcValidators() {
    const userCtcDetailsControl = this.employeeForm.get('userCtcDetails');

    if (this.empType === 'Article') {
      // Remove validators when empType is 'Article'
      userCtcDetailsControl?.clearValidators();
    } else {
      // Set validators when empType is not 'Article'
      userCtcDetailsControl?.setValidators([Validators.required]);
    }

    // Update the control to apply the changes
    userCtcDetailsControl?.updateValueAndValidity();
  }



  addPartnerFormGroup(): FormGroup {
    return this.fb.group({
      id: [''],
      reportingPartner: ['', Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
    });
  }

  removePartnerButtonClick(index: number): void {
    const formArray = <FormArray>this.employeeForm.get('reportingPartners');
    for (let i = index; i < this.employeeForm.value.reportingPartners.length; i++) {
      formArray.removeAt(i);
      i--;
    }
    formArray.markAsDirty();
    formArray.markAsTouched();
  }
  // ADD Ctc
  ctcFormSubmitted = false;
  ctcForm;
  ctcFormErrors = ProfileCommon.employeeCtcFormErrors;
  ctcFormValidationMessages = ProfileCommon.employeeCtcFormValidationMessages;
  initCtcDetails() {

    this.ctcForm = this.fb.group({
      ctc: [0, [Validators.required]],
      basic: [0, [Validators.required]],
      childHostelAllowance: [0],
      variableComponentPercent: [0, [Validators.required]],
      variableComponent: [0],
      uanNo: [0, [Validators.required]],
      conveyanceAllowance: [0, [Validators.required]],
      // educationAllowance: [0, [Validators.required]],
      esic: [0, [Validators.required]],
      exgratia: [0, [Validators.required]],
      exgratiaMonth: [''],
      fromDate: ['', [Validators.required]],
      hra: [0, [Validators.required]],
      medicalAllowance: [0, [Validators.required]],
      mobileAllowance: [0, [Validators.required]],
      professionalExceptionMonth: [{ "no": 2, "abbreviation": "Feb", "name": "February" }, [Validators.required]],
      professionalExceptionTax: [0, [Validators.required]],
      professionalTax: [200, [Validators.required]],
      providentFund: [0, [Validators.required]],
      securityDeposit: [0, [Validators.required]],
      securityFromDate: [''],
      securityToDate: [''],
      toDate: ['', [Validators.required]],
      designation: ['', [Validators.required]],
      overtimeApplicability: [null, [Validators.required]],
      epfApplicable: [null, [Validators.required]],
      laptopEligibility: [null, [Validators.required]],
      loan: [0, [Validators.required]],
      loanFromDate: [''],
      loanToDate: [''],
      emi: [0, [Validators.required]],
      advance: [0, [Validators.required]],
      advanceMonth: null,
      recoveryOrExpenses: [0, [Validators.required]],
      recoveryMonth: null,
      userCtcTds: this.fb.array([this.addCtcTdsFormGroup()]),
    })
    const from = this.ctcForm.get('loanFromDate');
    const to = this.ctcForm.get('loanToDate');

    from?.clearValidators();
    to?.clearValidators();

    from?.updateValueAndValidity();
    to?.updateValueAndValidity();
  }

  removeCtcButtonClick(index: number): void {
    const formArray = <FormArray>this.employeeForm.get('userCtcDetails');
    formArray.removeAt(index);
    formArray.markAsDirty();
    formArray.markAsTouched();
  }

  addCtcTdsButtonClick() {
    (<FormArray>this.ctcForm.get('userCtcTds')).push(this.addCtcTdsFormGroup());
  }

  addCtcTdsFormGroup(): FormGroup {
    return this.fb.group({
      tds: [undefined, [Validators.required]],
      fromDate: [null, [Validators.required]],
      toDate: [null, [Validators.required]],
    });
  }
  // this.ctcForm.value.fromDate
  // this.ctcForm.value.toDate

  removeCtcTdsButtonClick(index: number): void {
    const formArray = <FormArray>this.ctcForm.get('userCtcTds');
    formArray.removeAt(index);
    formArray.markAsDirty();
    formArray.markAsTouched();
  }

  resetCTCForm() {
    this.ctcFormSubmitted = false;
    this.ctcForm.reset();
    this.ctcForm.controls['userCtcTds'].clear();
  }

  // --------------------------------------------------------------------------
  isPartner = false;
  onChange() {
    console.log("in on chnage")
    this.isPartner = false;
    const partnerRoles = ['Partner', 'Managing Partner', 'Designated Partner'];

    for (let i = 0; i < this.employeeForm.controls.droles.value.length; i++) {
      if (partnerRoles.includes(this.employeeForm.controls.droles.value[i].name)) {
        this.isPartner = true;
        this.employeeForm.controls.reportingPartners.clear();
        this.employeeForm.get('reportingManager').clearValidators();
        this.employeeForm.get('reportingManager').updateValueAndValidity();
      }
    }
    if (!this.isPartner) {
      if (this.employeeForm.controls.reportingPartners.length == 0) {
        if (this.employeeForm.controls.reportingPartners)

          this.addPartnerButtonClick();
        ((this.employeeForm.get('reportingPartners') as FormArray).at(0) as FormGroup).get('startDate')
          .patchValue(this.employeeForm.controls['joiningDate'].value);

        var minDate1 = new Date(this.employeeForm.value.reportingPartners[0].startDate.year + "-12-31")
        var minDate2 = moment(minDate1, 'MM/DD/YYYY');
        var minDate3 = { year: parseInt(minDate2.format('YYYY')), month: parseInt(minDate2.format('M')), day: parseInt(minDate2.format('D')) };

        ((this.employeeForm.get('reportingPartners') as FormArray).at(0) as FormGroup).get('endDate')
          .patchValue(minDate3);
      }
    }
  }

  onChangeEmployeeType() {
    this.setCtcValidators();
    if (this.empType == "Article") {
      //  this.employeeForm.get('basic').clearValidators();
      //  this.employeeForm.get('hra').clearValidators();
      //  this.employeeForm.get('otherAllowance').clearValidators();
      //  this.employeeForm.get('conveyanceAllowance').clearValidators();
      //  this.employeeForm.get('medicalAllowance').clearValidators();
      //  this.employeeForm.get('educationAllowance').clearValidators();
      //  this.employeeForm.get('childHostelAllowance').clearValidators();
      //  this.employeeForm.get('fromDate').clearValidators();
      //  this.employeeForm.get('toDate').clearValidators();
      //-------------------------------------------------

      this.employeeForm.get('certificationType').clearValidators();
      console.log(this.employeeForm.get('certificationType'));
      this.employeeForm.get('officalMobileNumber').clearValidators();
      console.log(this.employeeForm.get('officalMobileNumber'));
      this.employeeForm.get('droles').clearValidators();
      this.employeeForm.get('designation').clearValidators();
      this.employeeForm.get('membershipNumber').clearValidators();
      this.employeeForm.get('membershipNumber').disable();
      this.employeeForm.get('dateOfMembershipNumber').clearValidators();
      this.employeeForm.get('probabtionPeriod').clearValidators();
      //  this.employeeForm.get('verified').clearValidators();
      this.employeeForm.get('confirmationDate').clearValidators();
      this.employeeForm.get('commitmentDate').clearValidators();
      this.employeeForm.get('commitmentDate').updateValueAndValidity();
      //  this.employeeForm.get('verificationSource').clearValidators();
      this.employeeForm.get('remark').clearValidators();
      this.employeeForm.get('scholarship').clearValidators();
      //  this.employeeForm.get('articleTrainingLimit').clearValidators();

      this.employeeForm.get('articleType').setValidators(Validators.required);
      this.employeeForm.get('registeredPartner').setValidators(Validators.required);
      this.employeeForm.get('clients').clearValidators();
      this.employeeForm.get('serviceVerticle').clearValidators();
      this.employeeForm.get('serviceVerticle').updateValueAndValidity();
      this.employeeForm.get('userQualifications').clearValidators();
      this.employeeForm.get('userQualifications').updateValueAndValidity();
      this.employeeForm.get('qualification').setValidators(Validators.required);
      this.employeeForm.get('qualification').updateValueAndValidity();
      this.ctcForm.get('overtimeApplicability').clearValidators();
      this.ctcForm.get('overtimeApplicability').updateValueAndValidity();
      this.ctcForm.get('epfApplicable').clearValidators();
      this.ctcForm.get('laptopEligibility').updateValueAndValidity();
      this.ctcForm.get('variableComponentPercent').updateValueAndValidity();

      //this.employeeForm.get('userCtcDetails').clearValidators();
    } else {
      //  this.employeeForm.get('basic').setValidators(Validators.required);
      //  this.employeeForm.get('hra').setValidators(Validators.required);
      //  this.employeeForm.get('otherAllowance').setValidators(Validators.required);
      //  this.employeeForm.get('conveyanceAllowance').setValidators(Validators.required);
      //  this.employeeForm.get('medicalAllowance').setValidators(Validators.required);
      //  this.employeeForm.get('educationAllowance').setValidators(Validators.required);
      //  this.employeeForm.get('childHostelAllowance').setValidators(Validators.required);
      //  this.employeeForm.get('fromDate').setValidators(Validators.required);
      //  this.employeeForm.get('toDate').setValidators(Validators.required);
      //-------------------------------------------------------------
      this.employeeForm.get('officalMobileNumber').setValidators(Validators.required);
      this.employeeForm.get('certificationType').setValidators(Validators.required);
      this.employeeForm.get('droles').setValidators(Validators.required);
      this.employeeForm.get('designation').setValidators(Validators.required);
      this.ctcForm.get('overtimeApplicability').setValidators(Validators.required);
      this.ctcForm.get('epfApplicable').setValidators(Validators.required);
      this.employeeForm.get('membershipNumber').setValidators(Validators.required);
      // this.employeeForm.get('membershipNumber').disable();
      this.employeeForm.get('dateOfMembershipNumber').setValidators(Validators.required);
      this.employeeForm.get('probabtionPeriod').setValidators(Validators.required);
      //  this.employeeForm.get('verified').setValidators(Validators.required);
      this.employeeForm.get('confirmationDate').setValidators(Validators.required);

      //  this.employeeForm.get('verificationSource').setValidators(Validators.required);
      this.employeeForm.get('remark').setValidators(Validators.required);
      this.employeeForm.get('serviceVerticle').setValidators(Validators.required);
      this.employeeForm.get('serviceVerticle').updateValueAndValidity();
      this.employeeForm.get('qualification').clearValidators();
      this.employeeForm.get('qualification').updateValueAndValidity();
      this.employeeForm.get('userQualifications').setValidators(Validators.required);
      this.employeeForm.get('userQualifications').updateValueAndValidity();
      //this.employeeForm.get('userCtcDetails').setValidators(Validators.required);
      //  this.employeeForm.get('articleTrainingLimit').setValidators(Validators.required);

      this.employeeForm.get('articleType').clearValidators();
      this.employeeForm.get('registeredPartner').clearValidators();
      this.employeeForm.get('articleshipEndDate').clearValidators();
      this.employeeForm.get('icaiRegistrationDate').clearValidators();
      this.employeeForm.get('icaiRegistrationNumber').clearValidators();

      if (this.empType == "Consultant") {
        this.employeeForm.get('clients').setValidators(Validators.required);
        this.employeeForm.get('commitmentDate').clearValidators();
        this.employeeForm.get('commitmentDate').updateValueAndValidity();
      } else {
        this.employeeForm.get('clients').clearValidators();
        this.employeeForm.get('commitmentDate').setValidators(Validators.required);
        this.employeeForm.get('commitmentDate').updateValueAndValidity();
      }

    }
    // this.employeeForm.get('basic').updateValueAndValidity();
    // this.employeeForm.get('hra').updateValueAndValidity();
    // this.employeeForm.get('otherAllowance').updateValueAndValidity();
    // this.employeeForm.get('conveyanceAllowance').updateValueAndValidity();
    // this.employeeForm.get('medicalAllowance').updateValueAndValidity();
    // this.employeeForm.get('educationAllowance').updateValueAndValidity();
    // this.employeeForm.get('childHostelAllowance').updateValueAndValidity();
    // this.employeeForm.get('fromDate').updateValueAndValidity();
    // this.employeeForm.get('toDate').updateValueAndValidity();

    //-----------------------------
    this.employeeForm.get('officalMobileNumber').updateValueAndValidity();
    this.employeeForm.get('certificationType').updateValueAndValidity();
    this.employeeForm.get('droles').updateValueAndValidity();
    this.employeeForm.get('designation').updateValueAndValidity();
    this.ctcForm.get('overtimeApplicability').updateValueAndValidity();
    this.ctcForm.get('epfApplicable').updateValueAndValidity();
    this.employeeForm.get('membershipNumber').updateValueAndValidity();
    this.employeeForm.get('dateOfMembershipNumber').updateValueAndValidity();
    this.employeeForm.get('probabtionPeriod').updateValueAndValidity();
    // this.employeeForm.get('verified').updateValueAndValidity();
    this.employeeForm.get('confirmationDate').updateValueAndValidity();

    // this.employeeForm.get('verificationSource').updateValueAndValidity();
    this.employeeForm.get('remark').updateValueAndValidity();
    //  this.employeeForm.get('articleTrainingLimit').updateValueAndValidity();
    this.employeeForm.get('articleType').updateValueAndValidity();
    this.employeeForm.get('registeredPartner').updateValueAndValidity();
    this.employeeForm.get('articleshipEndDate').updateValueAndValidity();
    this.employeeForm.get('icaiRegistrationDate').updateValueAndValidity();
    this.employeeForm.get('icaiRegistrationNumber').updateValueAndValidity();
    this.employeeForm.get('clients').updateValueAndValidity();
  }

  onChangeArticleType() {
    if (this.employeeForm.controls.articleType.value) {

      var articleType = this.employeeForm.controls.articleType.value;
      if (articleType == 'Temporary') {
        this.employeeForm.controls.icaiRegistrationDate.setValue(null);
        this.employeeForm.controls.icaiRegistrationNumber.setValue(null);
        this.employeeForm.controls.articleshipEndDate.setValue(null);
        this.employeeForm.controls.registeredPartner.setValue(null);

        this.employeeForm.get('icaiRegistrationDate').clearValidators();
        this.employeeForm.get('icaiRegistrationNumber').clearValidators();
        this.employeeForm.get('articleshipEndDate').clearValidators();
        this.employeeForm.get('registeredPartner').clearValidators();
      } else {
        this.employeeForm.get('icaiRegistrationDate').setValidators(Validators.required);
        this.employeeForm.get('icaiRegistrationNumber').setValidators(Validators.required);
        this.employeeForm.get('articleshipEndDate').setValidators(Validators.required);
        this.employeeForm.get('registeredPartner').setValidators(Validators.required);
      }
      this.employeeForm.get('icaiRegistrationDate').updateValueAndValidity();
      this.employeeForm.get('icaiRegistrationNumber').updateValueAndValidity();
      this.employeeForm.get('articleshipEndDate').updateValueAndValidity();
      this.employeeForm.get('registeredPartner').updateValueAndValidity();
      this.employeeForm.get('scholarship').updateValueAndValidity();

    }

  }

  loadProfiles() {
    this.humanResourceService.getManageProfile(this.page, this.limit)
      .subscribe((res: any) => {

        this.employeeFormList = res;
        console.log("employeeList", this.employeeFormList)

        // this.loadDesignations();
        this.loadLookupForManageProfile();
      });
  }

  loadLookupForManageProfile() {
    this.humanResourceService.getLookupForManageProfile()
      .subscribe((res: any) => {

        this.designationList = res.designations;
        this.roleList = res.roles;
        this.branchList = res.branches;
        this.reportingPartnerList = res.partners;
        this.registerPartnerList = res.registerPartners
        this.reportingManagerList = res.managers;
        this.clientList = res.clients;
        this.stateList = res.states;
        this.certificationList = res.certificationTypes;

      });






  }

  loadLookupOfQualificationAndServicevertical() {
    this.humanResourceService.getQualificationsLookup()
      .subscribe((res: any) => {
        this.qualificationList = res;
        console.log("qualificationList", this.qualificationList)
      })

    this.humanResourceService.getServiceVerticalLookup()
      .subscribe((res: any) => {
        this.serviceVerticalList = res;
        console.log("serviceVerticalList", this.serviceVerticalList)
      })

    this.humanResourceService.getOvertimeApplicabilityLookup()
      .subscribe((res: any) => {
        this.overtimeApplicabilityList = res;
        console.log("overtimeApplicabilityList", this.overtimeApplicabilityList)
      })
  }



  selectAllClient(clients) {
    if (clients._selected) {
      this.employeeForm.get('clients').setValue(this.clientList);
      clients._selected = true;
    }
    if (clients._selected == false) {
      this.employeeForm.get('clients').setValue([]);
    }
  }

  // loadDesignations() {
  //   this.masterDataService.getDesignations()
  //     .subscribe(res => {
  //       this.designationList = res;
  //       // this.loadRoles();
  //     });
  // }

  // loadRoles() {
  //   this.masterDataService.getRoles()
  //     .subscribe(res => {
  //       this.roleList = res;
  //       // this.loadBranch();
  //     });
  // }

  // loadBranch() {
  //   this.masterDataService.getBranch()
  //     .subscribe(res => {

  //       this.branchList = res;
  //       // this.loadPartners();
  //     });
  // }

  // loadPartners() {
  //   this.masterDataService.getPartners()
  //     .subscribe(res => {

  //       this.reportingPartnerList = res;
  //       // this.loadClients();
  //     });
  // }

  // loadClients() {
  //   this.masterDataService.getClients().subscribe((res) => {
  //     console.log(res);
  //     this.clientList = res;
  //     this.loadState();
  //   });
  // }

  // loadState() {
  //   this.masterDataService.getStates().subscribe((res) => {
  //     this.stateList = res;
  //   });
  // };

  loadLocalCities(value) {
    if (value != null) {
      this.masterDataService.getCities(value.id).subscribe((res) => {
        this.localCityList = res;
        this.showLocalCity = true;
        this.showLocalPostCode = true;
      });
    }
  }

  loadLocalPostcode(value) {
    this.masterDataService.getPostcode(value.id).subscribe((res) => {
      this.localPostcodeList = res;
    });
  };

  loadPermanantCities(value) {
    console.log('city value', value);
    if (value != null) {
      this.masterDataService.getCities(value.id).subscribe((res) => {
        this.permanentCityList = res;
        this.showPermanentCity = true;
        this.showPermanentPostCode = true;
      });
    }
  }

  loadPermanantPostcode(value) {
    this.masterDataService.getPostcode(value.id).subscribe((res) => {
      this.permanentPostcodeList = res;
    });
  };

  onDeleteClick(item) {
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalStatus = 'delete';
        this.humanResourceService.deleteProfile(item.userId).subscribe((resp) => {
          this.changeModalFormObjList(item);
          this.commonMessageService.swalAlertWithIcon('', 'Deleted Successfully!', 'success');
        })
      }
    })
  }

  onAddBtnClick() {
    this.openModal('add');
    this.ngOnInit();
    this.employeeForm.get('email').enable();
  }

  onSaveClick() {
    this.employeeFormSubmitted = true;
    const ctcDetailsControl = this.employeeForm.get('userCtcDetails');
    ctcDetailsControl.clearValidators();
    ctcDetailsControl.updateValueAndValidity();
    this.logValidationErrors(this.employeeForm);
    console.log("this.employeeForm", this.employeeForm)
    console.log("this.employeeForm.valid", this.employeeForm.valid)
    if (this.employeeForm.valid) {
      this.humanResourceService.saveProfile(this.getJsonFromModal('save'))
        .subscribe(resp => {
          this.changeModalFormObjList(resp);
          this.closeModal();
          this.onUploadUserDocumentClick(resp);
          //this.onUploadUserDocumentClickOnSave(resp);
          this.commonMessageService.swalAlertWithIcon('', 'Saved Successfully!', 'success');
        })
    } else {
      console.log("employeeFormErrors", this.employeeFormErrors)
      this.commonMessageService.swalAlertWithoutIcon('', "please check form errors!")
    }
  }

  onQualificationsChange(): void {
    console.log('userQ', this.employeeForm.get('userQualifications')?.value);
    this.employeeForm.get('userQualifications')?.valueChanges.subscribe(values => {
      const isCA = values.some((q: any) => q.name === 'Chartered Accountant (CA)');
      const membershipNumberControl = this.employeeForm.get('membershipNumber');
      console.log('Is CA selected?', isCA);
      if (isCA) {
        membershipNumberControl?.enable();
      } else {
        membershipNumberControl?.disable();
      }
    });

  }



  // Edit Profile
  initEmployeeFormForEdit(formObj) {
    this.resetEmployeeForm();
    // this.employeeForm.get('password').clearValidators();
    // this.employeeForm.get('password').updateValueAndValidity();
    this.employeeForm.get('email').disable();
    this.viewModalFormObj(formObj);
  }

  onEditClick(formObj) {
    this.showCTCFromDate = false;
    this.initEmployeeFormForEdit(formObj);
  }

  viewModalFormObj(formObj) {
    this.humanResourceService.viewProfile(formObj.userId).subscribe((resp) => {
      this.setJsonToModal(resp);

    });
  }

  onUpdateClick() {
    console.log(' update click', this.employeeForm, this.employeeForm.value.userId);
    const reportingManagerControl = this.employeeForm.get('reportingManager');
    const ctcDetailsControl = this.employeeForm.get('userCtcDetails');
    if (this.empType !== 'Article') {
      console.log('type--', (this.empType));
      this.designation = this.employeeForm.get('designation')?.value.name;
      console.log('designation--', this.designation);
      if (this.designation === 'Partner') {
        console.log('inside if condition reportingManagerControl.clearValidators()');
        reportingManagerControl.clearValidators();
      } else {
        reportingManagerControl.setValidators([Validators.required]);
      }
    }
    reportingManagerControl.updateValueAndValidity();
    console.log('reportingManagerControl.errors', reportingManagerControl.errors);
    ctcDetailsControl.clearValidators();
    ctcDetailsControl.updateValueAndValidity();

    this.employeeFormSubmitted = true;
    this.logValidationErrors(this.employeeForm);
    if (this.employeeForm.valid) {
      // console.log('Final Json', this.getJsonFromModal('edit'));
      this.humanResourceService.updateProfile(this.getJsonFromModal('edit'), this.employeeForm.value.userId)
        .subscribe(resp => {
          console.log("resp", resp)
          this.changeModalFormObjList(resp);
          if (resp.userDocStatus == 'Pending') {
            this.onUploadUserDocumentClick(resp)
          }
          this.commonMessageService.swalAlertWithIcon('', 'Updated Successfully!', 'success');
          if (resp != null) {
            this.closeModal();
          }
        })
    } else {
      console.log("employeeFormErrors", this.employeeFormErrors)
      this.commonMessageService.swalAlertWithoutIcon('', "please check form errors!")
    }
  }


  onUploadUserDocumentClickOnSave(resp) {
    this.selectedUserDocumentUpload = resp;
    this.selectedUserDocumentUpload["userId"] = resp.userId;

    this.documentType = "";
    this.openUserProfileModal();
  };

  fileUploadChange(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      let file: File = this.fileList[0];
      this.formData = new FormData();
      this.formData.append('file', file);
      this.isFileValid = true;
    } else {
      this.isFileValid = false;
    }

  }

  ocList = [];
  //Setting
  changeModalFormObjList(modalFormObj) {
    console.log('change model form obj', modalFormObj);
    if (this.modalStatus == 'add') {
      this.employeeFormList.push(modalFormObj);
    }
    if (this.modalStatus == 'edit') {
      var index = this.employeeFormList.findIndex(item => item.id === modalFormObj.id)
      this.employeeFormList.splice(index, 1, modalFormObj);
    }
    if (this.modalStatus == 'delete') {
      var index = this.employeeFormList.findIndex(item => item.id === modalFormObj.id)
      this.employeeFormList.splice(index, 1);
    }
  }

  resetEmployeeForm() {
    this.empType = 'Employee';
    this.onChangeEmployeeType();
    this.showPermanentCity = false;
    this.showPermanentPostCode = false;
    this.showLocalCity = false;
    this.showLocalPostCode = false;
    this.employeeFormSubmitted = false;
    this.employeeForm.reset();
    this.employeeForm.controls['localAddress'].patchValue({ type: "local" });
    this.employeeForm.controls['permanentAddress'].patchValue({ type: "permanent" });
    this.employeeForm.controls['reportingPartners'].clear();
    this.employeeForm.controls['userCtcDetails'].clear();
  }

  enablePermanentCity() {
    var stateId = this.employeeForm.value.permanentAddress.state.id;
    this.employeeForm.controls['permanentAddress'].patchValue({ city: null });
    this.masterDataService.getCities(stateId).subscribe((res) => {
      this.permanentCityList = res;
      this.showPermanentCity = true;
    });
  }

  enablePermanentPostCode() {
    if (this.employeeForm.value.permanentAddress.city != null) {
      var cityId = this.employeeForm.value.permanentAddress.city.id;
      this.employeeForm.controls['permanentAddress'].patchValue({ postalCode: null });
      this.masterDataService.getPostcode(cityId).subscribe((res) => {
        this.permanentPostcodeList = res;
        this.showPermanentPostCode = true;
      });
    }
  }

  enableLocalCity() {
    var stateId = this.employeeForm.value.localAddress.state.id;
    this.employeeForm.controls['localAddress'].patchValue({ city: null });
    this.masterDataService.getCities(stateId).subscribe((res) => {
      this.localCityList = res;
      this.showLocalCity = true;
    });
  }

  enableLocalPostCode() {
    if (this.employeeForm.value.localAddress.city != null) {
      var cityId = this.employeeForm.value.localAddress.city.id;
      this.employeeForm.controls['localAddress'].patchValue({ postalCode: null });
      this.masterDataService.getPostcode(cityId).subscribe((res) => {
        this.localPostcodeList = res;
        this.showLocalPostCode = true;
      });
    }
  }

  getMaxDate(i) {
    var minDate3;

    var minDate1 = new Date(this.employeeForm.value.reportingPartners[i].startDate.year + "-12-31")
    var minDate2 = moment(minDate1, 'MM/DD/YYYY');
    minDate3 = { year: parseInt(minDate2.format('YYYY')), month: parseInt(minDate2.format('M')), day: parseInt(minDate2.format('D')) };
    this.employeeForm.controls.reportingPartners.controls[i].controls.endDate.setValue(minDate3);

    return minDate3;
  }
  getMinDate(i) {
    var minDate3;
    if (i > 0) {
      var minDate1 = new Date(this.employeeForm.value.reportingPartners[i - 1].endDate.year + '-' + this.employeeForm.value.reportingPartners[i - 1].endDate.month + '-' + this.employeeForm.value.reportingPartners[i - 1].endDate.day);
      minDate1.setDate(minDate1.getDate() + 1);
      var minDate2 = moment(minDate1, 'YYYY/MM/DD');
      minDate3 = { year: parseInt(minDate2.format('YYYY')), month: parseInt(minDate2.format('M')), day: parseInt(minDate2.format('D')) };
    }
    return minDate3;
  }

  formatDate(date: NgbDateStruct): string {
    console.log('type of date :', typeof date);

    if (date == null) {
      return null;
    }
    if (typeof date == 'string') {
      return date;
    } else {
      if (date.day != null && date.month != null && date.year != null) {
        console.log('format date', date);
        const year = date.year.toString().padStart(4, '0');
        const month = date.month.toString().padStart(2, '0');
        const day = date.day.toString().padStart(2, '0');
        return `${year}-${month}-${day}T00:00:00.000+00:00`;
      }
    }
  }

  ICAIRegDateChanged() {


    // Check if icaiRegistrationDate or any of its components are missing
    const icaiRegDateObj = this.employeeForm.value.icaiRegistrationDate;
    if (!icaiRegDateObj || !icaiRegDateObj.year || !icaiRegDateObj.month || !icaiRegDateObj.day) {
      console.log('icaiRegistrationDate is incomplete or missing. Skipping ICAIRegDateChanged.');
      return; // Exit the function if any part of the date is invalid
    }

    // Proceed if icaiRegistrationDate is valid

    this.articleshipTenureResponse = null;
    var icaiRegDate = this.employeeForm.value.icaiRegistrationDate.year + '-' + this.employeeForm.value.icaiRegistrationDate.month + '-' + this.employeeForm.value.icaiRegistrationDate.day;
    this.humanResourceService.getArticleshipTenure(icaiRegDate)
      .subscribe((res: any) => {
        console.log('response', res);

        this.articleshipTenureResponse = res;

        if (!this.articleshipTenureResponse) {
          if (this.empType == 'Article' && !(this.employeeForm.value.articleType == 'Temporary')) {

            var icaiRefDate1 = new Date(this.employeeForm.value.icaiRegistrationDate.year + '-' + this.employeeForm.value.icaiRegistrationDate.month + '-' + this.employeeForm.value.icaiRegistrationDate.day);

            icaiRefDate1.setMonth(icaiRefDate1.getMonth() + 36);
            icaiRefDate1.setDate(icaiRefDate1.getDate() - 1);
            var icaiRefDate2 = moment(icaiRefDate1, 'YYYY/MM/DD');
            var icaiRegistrationDate = { year: parseInt(icaiRefDate2.format('YYYY')), month: parseInt(icaiRefDate2.format('M')), day: parseInt(icaiRefDate2.format('D')) };
            this.employeeForm.controls['articleshipEndDate'].patchValue(icaiRegistrationDate);
            console.log('icaiRegistrationDate...', icaiRegistrationDate);
          }
        }
        else if (this.articleshipTenureResponse.tenureYears) {
          if (this.empType == 'Article' && !(this.employeeForm.value.articleType == 'Temporary')) {

            var icaiRefDate1 = new Date(this.employeeForm.value.icaiRegistrationDate.year + '-' + this.employeeForm.value.icaiRegistrationDate.month + '-' + this.employeeForm.value.icaiRegistrationDate.day);

            icaiRefDate1.setMonth(icaiRefDate1.getMonth() + 24);
            icaiRefDate1.setDate(icaiRefDate1.getDate() - 1);
            var icaiRefDate2 = moment(icaiRefDate1, 'YYYY/MM/DD');
            var icaiRegistrationDate = { year: parseInt(icaiRefDate2.format('YYYY')), month: parseInt(icaiRefDate2.format('M')), day: parseInt(icaiRefDate2.format('D')) };
            this.employeeForm.controls['articleshipEndDate'].patchValue(icaiRegistrationDate);
            console.log('icaiRegistrationDate...', icaiRegistrationDate);
          }

        }

      });


  }

  joiningDateChanged() {
    if (this.empType == 'Article' && !(this.employeeForm.value.articleType == 'Temporary')) {
      // var joiningDate1 = new Date(this.employeeForm.value.joiningDate.year + '-' + this.employeeForm.value.joiningDate.month + '-' + this.employeeForm.value.joiningDate.day);
      // joiningDate1.setMonth(joiningDate1.getMonth() + 36);
      // joiningDate1.setDate(joiningDate1.getDate() - 1);
      // var joiningDate2 = moment(joiningDate1, 'YYYY/MM/DD');
      // var joiningDate = { year: parseInt(joiningDate2.format('YYYY')), month: parseInt(joiningDate2.format('M')), day: parseInt(joiningDate2.format('D')) };
      // this.employeeForm.controls['articleshipEndDate'].patchValue(joiningDate);
      // console.log('joiningdate...', joiningDate);
    } else {
      // moment(this.employeeForm.value.joiningDate.day).date()-1
      var joiningDate1 = new Date(this.employeeForm.value.joiningDate.year + '-' + this.employeeForm.value.joiningDate.month + '-' + this.employeeForm.value.joiningDate.day);
      joiningDate1.setMonth(joiningDate1.getMonth() + this.employeeForm.value.probabtionPeriod);
      joiningDate1.setDate(joiningDate1.getDate() - 0);
      var joiningDate2 = moment(joiningDate1, 'YYYY/MM/DD');
      var joiningDate = { year: parseInt(joiningDate2.format('YYYY')), month: parseInt(joiningDate2.format('M')), day: parseInt(joiningDate2.format('D')) };
      this.employeeForm.controls['confirmationDate'].patchValue(joiningDate);
    }
  }

  // JSON GET PUT
  getAutoGeneratedPassword() {
    var password = ""
    if (this.employeeForm.value) {
      var emailStr = this.employeeForm.get('email').value;
      password = emailStr.substring(0, 5) + "@1";

    }
    return password;
  }

  getDesignationPerCurrentDate(ctcArray) {
    var designation = '';
    console.log(this.employeeForm.value.userCtcDetails)
    for (let i = 0; i < ctcArray.length; i++) {
      var fromDate = new Date(ctcArray[i].fromDate.year + '-' + ctcArray[i].fromDate.month + '-' + ctcArray[i].fromDate.day);
      var toDate = new Date(ctcArray[i].toDate.year + '-' + ctcArray[i].toDate.month + '-' + ctcArray[i].toDate.day);
      var currentDate = new Date();
      var fromattedFromDate = moment(fromDate).format('YYYY-MM-DD');
      var fromattedToDate = moment(toDate).format('YYYY-MM-DD');
      var formattedCurrentDate = moment(currentDate).format('YYYY-MM-DD');
      console.log("fromattedFromDate", fromattedFromDate)
      console.log("fromattedToDate", fromattedToDate)
      console.log("formattedCurrentDate", formattedCurrentDate)
      if (formattedCurrentDate >= fromattedFromDate && formattedCurrentDate <= fromattedToDate) {
        designation = ctcArray[i].designation;
      }
    }

    console.log("designation", designation)

    return designation
  }

  getJsonFromModal(status) {
    var jsonData = {}
    var userCertifications = [];
    var userQualifications = [];
    var serviceVertical = [];


    if (this.empType != "Article") {
      this.employeeForm.value.userQualifications.forEach((qualification, qualificationKey) => {
        const qualif = {
          "qualification": qualification,
          "description": "",
        };
        userQualifications.push(qualif);
      });
    }



    if (this.empType != 'Article') {
      console.log("certification", this.employeeForm.value.certificationType)

      if (status == 'edit') {
        this.employeeForm.value.serviceVerticle.forEach((service, serviceKey) => {
          const serviceV = {
            "id": service.id,
            "userServiceVerticle": service,
          };
          serviceVertical.push(serviceV);
        });
      } else {
        this.employeeForm.value.serviceVerticle.forEach((service, serviceKey) => {
          const serviceV = {
            "userServiceVerticle": service,
          };
          serviceVertical.push(serviceV);
        });
      }

      if (this.employeeForm.value.certificationType[0].name == "Others") {
        userCertifications = [
          {
            "certificationType": this.employeeForm.value.certificationType[0],
            "description": this.employeeForm.value.description,
          }
        ]
      } else {
        this.employeeForm.value.certificationType.forEach((certification, certificationKey) => {
          const cert = {
            "certificationType": certification,
            "description": "",
          };
          userCertifications.push(cert);
        });
      }
      console.log("userCertifications", userCertifications)
      console.log("userQualifications", userQualifications)
    }
    // var index = this.employeeForm.value.certificationType.findIndex(item => item.id === 6)
    // if (index >= 0) {
    //   userCertifications = [
    //     {
    //       "certificationType": { id: 6, name: "Others" },
    //       "description": this.employeeForm.value.description,
    //     }
    //   ]
    // } else {
    //   this.employeeForm.value.certificationType.forEach((certification, certificationKey) => {
    //     const cert = {
    //       "certificationType": certification,
    //       "description": "",
    //     };
    //     userCertifications.push(cert);
    //   });
    // }

    var bankAcountName = '';
    if (this.employeeForm.value.bankAcountName == 'Other Bank') {
      bankAcountName = this.employeeForm.value.newBankAcountName;
    } else {
      bankAcountName = this.employeeForm.value.bankAcountName;
    }

    var reportingPartners = [];
    this.employeeForm.value.reportingPartners.forEach((partner, partnerKey) => {
      var startDate = new Date(
        partner.startDate.year +
        '-' +
        partner.startDate.month +
        '-' +
        partner.startDate.day
      );
      var endDate = new Date(
        partner.endDate.year +
        '-' +
        partner.endDate.month +
        '-' +
        partner.endDate.day
      );
      const part = {
        reportingPartner: partner.reportingPartner,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
      };
      reportingPartners.push(part)

    })

    var designation
    designation = this.getDesignationPerCurrentDate(this.employeeForm.value.userCtcDetails)
    if (designation == '') {
      designation = this.employeeForm.value.designation
    }
    var userId
    if (status == 'save') {
      userId = null
    } else {
      userId = this.employeeForm.value.userId
    }

    var membershipDate
    if (this.employeeForm.value.dateOfMembershipNumber != null) {
      membershipDate = new Date(this.employeeForm.value.dateOfMembershipNumber.year + '-' + this.employeeForm.value.dateOfMembershipNumber.month + '-' + this.employeeForm.value.dateOfMembershipNumber.day);
    } else {
      membershipDate = null
    }

    if (this.empType == "Article") {
      console.log('Yes i am article', this.employeeForm.value.officalMobileNumber);
      // Article
      if (this.employeeForm.value.articleType == 'Temporary') {

        var dateOfBirth = new Date(this.employeeForm.value.dateOfBirth.year + '-' + this.employeeForm.value.dateOfBirth.month + '-' + this.employeeForm.value.dateOfBirth.day);
        var joiningDate = new Date(this.employeeForm.value.joiningDate.year + '-' + this.employeeForm.value.joiningDate.month + '-' + this.employeeForm.value.joiningDate.day);

        jsonData = {
          "id": this.employeeForm.value.id,
          "userId": userId,
          "type": this.empType,
          "addresses": [
            {
              ...this.employeeForm.value.permanentAddress,
              type: "permanent" // Explicitly set type
            },
            {
              ...this.employeeForm.getRawValue().localAddress,
              type: "local" // Explicitly set type
            }
          ],
          "droles": [{
            "id": 1,
            "name": "Article"
          }],
          "email": this.employeeForm.get('email').value,
          "firstName": this.employeeForm.value.firstName,
          "lastName": this.employeeForm.value.lastName,
          "middleName": this.employeeForm.value.middleName,
          "password": this.getAutoGeneratedPassword(),
          "userCtcDetails": [],
          "userExitDetails": this.getUserExitDetails(),
          "userOfficialDetails": {
            "articleType": this.employeeForm.value.articleType,
            "branch": this.employeeForm.value.branch,
            "joiningDate": moment(joiningDate).format("YYYY-MM-DD"),
            "reportingManager": this.employeeForm.value.reportingManager,
            "reportingPartners": reportingPartners,
            "laptopServiceTagNumber": this.employeeForm.value.laptopServiceTagNumber,
            "bankAccountNumber": this.employeeForm.value.bankAccountNumber,
            "bankIfscCode": this.employeeForm.value.bankIfscCode,
            "bankAcountName": bankAcountName,
            // "dataCardNumber": this.employeeForm.value.dataCardNumber,
            "profileStatus": this.employeeForm.value.profileStatus,
            "scholarship": this.employeeForm.value.scholarship,
            "serviceVerticle": serviceVertical,
            "remark": this.employeeForm.value.remark
          },
          "userPersonalDetails": {
            "bloodGroup": this.employeeForm.value.bloodGroup,
            // "certification": this.employeeForm.value.certification,
            "contactMobileNumber": this.employeeForm.value.contactMobileNumber,
            "dateOfBirth": moment(dateOfBirth).format("YYYY-MM-DD"),
            "emergencyContactName1": this.employeeForm.value.emergencyContactName1,
            "emergencyContactName2": this.employeeForm.value.emergencyContactName2,
            "emergencyContactNumber1": this.employeeForm.value.emergencyContactNumber1,
            "emergencyContactNumber2": this.employeeForm.value.emergencyContactNumber2,
            "emergencyContactRelation1": this.employeeForm.value.emergencyContactRelation1,
            "emergencyContactRelation2": this.employeeForm.value.emergencyContactRelation2,
            "gender": this.employeeForm.value.gender,
            // "landlineNumber": this.employeeForm.value.landlineNumber,
            // "landlineStdCode": this.employeeForm.value.landlineStdCode,
            "officalMobileNumber": this.employeeForm.value.officalMobileNumber,
            "panNumber": this.employeeForm.value.panNumber,
            "aadharNumber": this.employeeForm.value.aadharNumber,
            "personalEmail": this.employeeForm.value.personalEmail,
            "qualification": this.employeeForm.value.qualification,
            "userCertifications": userCertifications,
            "userQualifications": []
          }
        }
      } else {

        var dateOfBirth = new Date(this.employeeForm.value.dateOfBirth.year + '-' + this.employeeForm.value.dateOfBirth.month + '-' + this.employeeForm.value.dateOfBirth.day);
        var articleshipEndDate = new Date(this.employeeForm.value.articleshipEndDate.year + '-' + this.employeeForm.value.articleshipEndDate.month + '-' + this.employeeForm.value.articleshipEndDate.day);
        var icaiRegistrationDate = new Date(this.employeeForm.value.icaiRegistrationDate.year + '-' + this.employeeForm.value.icaiRegistrationDate.month + '-' + this.employeeForm.value.icaiRegistrationDate.day);
        var joiningDate = new Date(this.employeeForm.value.joiningDate.year + '-' + this.employeeForm.value.joiningDate.month + '-' + this.employeeForm.value.joiningDate.day);

        jsonData = {
          "id": this.employeeForm.value.id,
          "userId": userId,
          "type": this.empType,
          "addresses": [
            {
              ...this.employeeForm.value.permanentAddress,
              type: "permanent" // Explicitly set type
            },
            {
              ...this.employeeForm.getRawValue().localAddress,
              type: "local" // Explicitly set type
            }
          ],
          "droles": [{
            "id": 1,
            "name": "Article"
          }],
          "email": this.employeeForm.get('email').value,
          "firstName": this.employeeForm.value.firstName,
          "lastName": this.employeeForm.value.lastName,
          "middleName": this.employeeForm.value.middleName,
          "password": this.getAutoGeneratedPassword(),
          "userCtcDetails": [],
          "userExitDetails": this.getUserExitDetails(),
          "userOfficialDetails": {
            "articleType": this.employeeForm.value.articleType,
            "branch": this.employeeForm.value.branch,
            "joiningDate": moment(joiningDate).format("YYYY-MM-DD"),
            "articleshipEndDate": moment(articleshipEndDate).format("YYYY-MM-DD"),
            "reportingManager": this.employeeForm.value.reportingManager,
            "reportingPartners": reportingPartners,
            "registeredPartner": this.employeeForm.value.registeredPartner,
            "icaiRegistrationDate": moment(icaiRegistrationDate).format("YYYY-MM-DD"),
            "icaiRegistrationNumber": this.employeeForm.value.icaiRegistrationNumber,
            "laptopServiceTagNumber": this.employeeForm.value.laptopServiceTagNumber,
            "pendingLeaves": this.articleshipTenureResponse && this.articleshipTenureResponse.leaves !== null
              ? this.articleshipTenureResponse.leaves
              : 0,
            "bankAccountNumber": this.employeeForm.value.bankAccountNumber,
            "bankIfscCode": this.employeeForm.value.bankIfscCode,
            "bankAcountName": bankAcountName,
            // "dataCardNumber": this.employeeForm.value.dataCardNumber,
            "profileStatus": this.employeeForm.value.profileStatus,
            "scholarship": this.employeeForm.value.scholarship,
            "serviceVerticle": serviceVertical,
            "remark": this.employeeForm.value.remark
          },
          "userPersonalDetails": {
            "bloodGroup": this.employeeForm.value.bloodGroup,
            // "certification": this.employeeForm.value.certification,
            "contactMobileNumber": this.employeeForm.value.contactMobileNumber,
            "dateOfBirth": moment(dateOfBirth).format("YYYY-MM-DD"),
            "emergencyContactName1": this.employeeForm.value.emergencyContactName1,
            "emergencyContactName2": this.employeeForm.value.emergencyContactName2,
            "emergencyContactNumber1": this.employeeForm.value.emergencyContactNumber1,
            "emergencyContactNumber2": this.employeeForm.value.emergencyContactNumber2,
            "emergencyContactRelation1": this.employeeForm.value.emergencyContactRelation1,
            "emergencyContactRelation2": this.employeeForm.value.emergencyContactRelation2,
            "gender": this.employeeForm.value.gender,
            // "landlineNumber": this.employeeForm.value.landlineNumber,
            // "landlineStdCode": this.employeeForm.value.landlineStdCode,
            "officalMobileNumber": this.employeeForm.value.officalMobileNumber,
            "panNumber": this.employeeForm.value.panNumber,
            "aadharNumber": this.employeeForm.value.aadharNumber,
            "personalEmail": this.employeeForm.value.personalEmail,
            "qualification": this.employeeForm.value.qualification,
            "userCertifications": userCertifications,
            "userQualifications": []
          }
        }
      }
    } else {
      console.log("not articel", this.employeeForm.value.userCtcDetails)
      var commitmentDate;
      // Not Article
      // var fromDate = new Date(this.employeeForm.value.fromDate.year+'-'+this.employeeForm.value.fromDate.month+'-'+this.employeeForm.value.fromDate.day);
      // var toDate = new Date(this.employeeForm.value.toDate.year+'-'+this.employeeForm.value.toDate.month+'-'+this.employeeForm.value.toDate.day);
      var dateOfBirth = new Date(this.employeeForm.value.dateOfBirth.year + '-' + this.employeeForm.value.dateOfBirth.month + '-' + this.employeeForm.value.dateOfBirth.day);
      var confirmationDate = new Date(this.employeeForm.value.confirmationDate.year + '-' + this.employeeForm.value.confirmationDate.month + '-' + this.employeeForm.value.confirmationDate.day);
      var joiningDate = new Date(this.employeeForm.value.joiningDate.year + '-' + this.employeeForm.value.joiningDate.month + '-' + this.employeeForm.value.joiningDate.day);

      if (this.empType == "Consultant") {
        commitmentDate = null;
      }
      else {
        commitmentDate = new Date(this.employeeForm.value.commitmentDate.year + '-' + this.employeeForm.value.commitmentDate.month + '-' + this.employeeForm.value.commitmentDate.day);
      }

      var clients = []
      if (this.employeeForm.value.clients) {
        clients = this.employeeForm.value.clients;
      }

      jsonData = {
        "id": this.employeeForm.value.id,
        "userId": userId,
        "type": this.empType,
        "addresses": [
          {
            ...this.employeeForm.value.permanentAddress,
            type: "permanent" // Explicitly set type
          },
          {
            ...this.employeeForm.getRawValue().localAddress,
            type: "local" // Explicitly set type
          }
        ],
        "designation": designation,
        "droles": this.employeeForm.value.droles,
        "email": this.employeeForm.get('email').value,
        "firstName": this.employeeForm.value.firstName,
        "lastName": this.employeeForm.value.lastName,
        "middleName": this.employeeForm.value.middleName,
        "password": this.getAutoGeneratedPassword(),
        "userCtcDetails": this.getUserCtcArray(),
        "userExitDetails": this.getUserExitDetails(),
        // "userId": this.employeeForm.value.userId,
        "userOfficialDetails": {
          "branch": this.employeeForm.value.branch,
          // "articleTrainingLimit": this.employeeForm.value.articleTrainingLimit,
          "bankAccountNumber": this.employeeForm.value.bankAccountNumber,
          "bankIfscCode": this.employeeForm.value.bankIfscCode,
          "bankAcountName": bankAcountName,
          "confirmationDate": moment(confirmationDate).format("YYYY-MM-DD"),
          "commitmentDate": commitmentDate ? moment(commitmentDate).format("YYYY-MM-DD") : null,
          // "dataCardNumber": this.employeeForm.value.dataCardNumber,
          "reportingManager": this.employeeForm.value.reportingManager,
          "reportingPartners": reportingPartners,
          "joiningDate": moment(joiningDate).format("YYYY-MM-DD"),
          "laptopServiceTagNumber": this.employeeForm.value.laptopServiceTagNumber,
          "membershipNumber": this.employeeForm.getRawValue().membershipNumber,
          "dateOfMembershipNumber": moment(membershipDate).format("YYYY-MM-DD"),
          "probabtionPeriod": this.employeeForm.value.probabtionPeriod,
          "remark": this.employeeForm.value.remark,
          "verificationSource": this.employeeForm.value.verificationSource,
          "verified": this.employeeForm.value.verified,
          "clients": clients,
          "profileStatus": this.employeeForm.value.profileStatus,
          "scholarship": this.employeeForm.value.scholarship,
          "serviceVerticle": serviceVertical
        },
        "userPersonalDetails": {
          "bloodGroup": this.employeeForm.value.bloodGroup,
          // "certification": this.employeeForm.value.certification,
          "contactMobileNumber": this.employeeForm.value.contactMobileNumber,
          "dateOfBirth": moment(dateOfBirth).format("YYYY-MM-DD"),
          "emergencyContactName1": this.employeeForm.value.emergencyContactName1,
          "emergencyContactName2": this.employeeForm.value.emergencyContactName2,
          "emergencyContactNumber1": this.employeeForm.value.emergencyContactNumber1,
          "emergencyContactNumber2": this.employeeForm.value.emergencyContactNumber2,
          "emergencyContactRelation1": this.employeeForm.value.emergencyContactRelation1,
          "emergencyContactRelation2": this.employeeForm.value.emergencyContactRelation2,
          "gender": this.employeeForm.value.gender,
          // "landlineNumber": this.employeeForm.value.landlineNumber,
          // "landlineStdCode": this.employeeForm.value.landlineStdCode,
          "officalMobileNumber": this.employeeForm.value.officalMobileNumber,
          "panNumber": this.employeeForm.value.panNumber,
          "aadharNumber": this.employeeForm.value.aadharNumber,
          "personalEmail": this.employeeForm.value.personalEmail,
          //"qualification": this.employeeForm.value.qualification,
          "userCertifications": userCertifications,
          "userQualifications": userQualifications
        }
      }
    }

    console.log('All json data', JSON.stringify(jsonData));
    console.log('All json data without stingfy', jsonData);
    return JSON.stringify(jsonData);
  }

  showCTCFromDate: Boolean;
  getUserCtcArray() {
    console.log('getuserCTCarray');
    var userCtcDetailsJson = [];
    this.showCTCFromDate = true;
    for (let i = 0; i < this.employeeForm.value.userCtcDetails.length; i++) {
      console.log('getuserCTCdetails', this.employeeForm.value.userCtcDetails[i].fromDate, " ", this.employeeForm.value.userCtcDetails[i].toDate)
      userCtcDetailsJson.push(this.employeeForm.value.userCtcDetails[i])
    }


    //this.userCtcDetailsJson = this.employeeForm.value.userCtcDetails;
    userCtcDetailsJson.forEach((userCtc, userCtcKey) => {
      console.log('before', userCtc.fromDate, " ", this.employeeForm.value.userCtcDetails[0].toDate)
      var fromDate = new Date(userCtc.fromDate.year + '-' + userCtc.fromDate.month + '-' + userCtc.fromDate.day);
      var toDate = new Date(userCtc.toDate.year + '-' + userCtc.toDate.month + '-' + userCtc.toDate.day);
      userCtc.fromDate = moment(fromDate).format('YYYY-MM-DD');
      userCtc.toDate = moment(toDate).format('YYYY-MM-DD');
      console.log('after', userCtc.fromDate, " ", this.employeeForm.value.userCtcDetails[0].toDate)
      userCtc.fromDate = userCtc.fromDate;
      // userCtc.toDate=userCtc.toDate;
      var securityFromDate;
      var securityToDate
      console.log(' userCtc.securityFromDate.........userCtc.securityToDate', userCtc.securityFromDate, " ", userCtc.securityToDate)
      if ((userCtc.securityFromDate == '' || userCtc.securityFromDate == null || userCtc.securityFromDate == undefined || userCtc.securityFromDate == 'Invalid date') || (userCtc.securityToDate == '' || userCtc.securityToDate == null || userCtc.securityToDate == undefined || userCtc.securityToDate == 'Invalid date')) {
        userCtc.securityFromDate = null;
        userCtc.securityToDate = null;
      } else {
        securityFromDate = new Date(userCtc.securityFromDate.year + '-' + userCtc.securityFromDate.month + '-' + userCtc.securityFromDate.day);
        securityToDate = new Date(userCtc.securityToDate.year + '-' + userCtc.securityToDate.month + '-' + userCtc.securityToDate.day);
        userCtc.securityFromDate = moment(securityFromDate).format('YYYY-MM-DD');
        userCtc.securityToDate = moment(securityToDate).format('YYYY-MM-DD');
      }// var newCtc = {...userCtc};
      // newCtc.userCtcTds = [];
      var loanFromDate;
      var loanToDate;
      console.log(' userCtc.loanFromDate.........userCtc.loanToDate', userCtc.loanFromDate, " ", userCtc.loanToDate)
      if ((userCtc.loanFromDate == '' || userCtc.loanFromDate == null || userCtc.loanFromDate == undefined || userCtc.loanFromDate == 'Invalid date') || (userCtc.loanToDate == '' || userCtc.loanToDate == null || userCtc.loanToDate == undefined || userCtc.loanToDate == 'Invalid date')) {
        userCtc.loanFromDate = null;
        userCtc.loanToDate = null;
      } else {
        loanFromDate = new Date(userCtc.loanFromDate.year + '-' + userCtc.loanFromDate.month + '-' + userCtc.loanFromDate.day);
        loanToDate = new Date(userCtc.loanToDate.year + '-' + userCtc.loanToDate.month + '-' + userCtc.loanToDate.day);
        userCtc.loanFromDate = moment(loanFromDate).format('YYYY-MM-DD');
        userCtc.loanToDate = moment(loanToDate).format('YYYY-MM-DD');
      }

      if (!Array.isArray(userCtc.userCtcTds)) {
        userCtc.userCtcTds = userCtc.userCtcTds ? [userCtc.userCtcTds] : [];
      }
      if (userCtc.userCtcTds && userCtc.userCtcTds.length) {
        userCtc.userCtcTds.forEach((ctcTds, ctcTdsKey) => {
          var tdsFromDate = new Date(ctcTds.fromDate.year + '-' + ctcTds.fromDate.month + '-' + ctcTds.fromDate.day);
          var tdsToDate = new Date(ctcTds.toDate.year + '-' + ctcTds.toDate.month + '-' + ctcTds.toDate.day);
          ctcTds.fromDate = moment(tdsFromDate).format('YYYY-MM-DD');
          ctcTds.toDate = moment(tdsToDate).format('YYYY-MM-DD');
        })
      }
    })


    console.log("userCtcDetailsJson", userCtcDetailsJson)
    console.log("userCtcDetailsJson2", this.employeeForm.value.userCtcDetails)

    return userCtcDetailsJson
  }

  userExitDetails: any;
  getUserExitDetails() {
    this.userExitDetails = null;
    if (this.employeeForm.value.userExitDetails) {
      if (this.employeeForm.value.userExitDetails.exitDate) {
        var exitDate = new Date(this.employeeForm.value.userExitDetails.exitDate.year + '-' + this.employeeForm.value.userExitDetails.exitDate.month + '-' + this.employeeForm.value.userExitDetails.exitDate.day);
        this.userExitDetails = { ...this.employeeForm.value.userExitDetails };
        this.userExitDetails.exitDate = moment(exitDate).format('YYYY-MM-DD');
      }
    }
    return this.userExitDetails;
  }

  gPState;
  gLState;
  gPCity;
  gLCity;
  isSameAddress;
  setJsonToModal(modalObj) {
    console.log('in set json model modalobj', modalObj);
    modalObj.addresses.map((res: any) => {
      console.log('inside address', res);
      if (res.type == 'permanent') {
        this.gPState = res.state;
        this.gPCity = res.city;
      } else if (res.type == 'local') {
        this.gLState = res.state;
        this.gLCity = res.city;
      }
    });
    if (this.gPCity == null) {
      this.loadPermanantCities(this.gPState);
    }
    if (this.gLCity == null) {
      this.loadLocalCities(this.gLState);
    }
    var dob1, dob2, dob;
    var userCertifications = [];
    var userQualifications = [];
    var serviceVerticleList = [];
    var description = "";
    if (modalObj.userPersonalDetails) {
      dob1 = new Date(modalObj.userPersonalDetails.dateOfBirth);
      dob2 = moment(dob1, 'YYYY/MM/DD');
      dob = { year: parseInt(dob2.format('YYYY')), month: parseInt(dob2.format('M')), day: parseInt(dob2.format('D')) };

      modalObj.userPersonalDetails.userCertifications.forEach((certification, certificationKey) => {
        if (certification.certificationType.id == 6) {
          description = certification.description;
          userCertifications.push()
        }
        userCertifications.push(certification.certificationType);
      })

      modalObj.userPersonalDetails.userQualifications.forEach((qualification, qualificationKey) => {

        userQualifications.push(qualification.qualification);
      })
      console.log("userQualifications patched", userQualifications);
    }
    this.onQualificationsChange();

    var joiningDate1, joiningDate2, joiningDate;
    var branchIndex = -1;

    if (modalObj.userOfficialDetails) {
      joiningDate1 = new Date(modalObj.userOfficialDetails.joiningDate);
      joiningDate2 = moment(joiningDate1, 'YYYY/MM/DD');
      joiningDate = { year: parseInt(joiningDate2.format('YYYY')), month: parseInt(joiningDate2.format('M')), day: parseInt(joiningDate2.format('D')) };
      if (modalObj.userOfficialDetails.branch) {
        branchIndex = this.branchList.findIndex((item) => item.id == modalObj.userOfficialDetails.branch.id);
      }


    }

    if (modalObj.type === "Article") {
      var articleshipEndDate;
      if (modalObj.userOfficialDetails.articleshipEndDate) {
        var date1 = new Date(modalObj.userOfficialDetails.articleshipEndDate);
        var date2 = moment(date1, 'YYYY/MM/DD');
        articleshipEndDate = { year: parseInt(date2.format('YYYY')), month: parseInt(date2.format('M')), day: parseInt(date2.format('D')) };
      }
    } else {
      var designationIndex = -1;
      if (modalObj.designation) {
        designationIndex = this.designationList.findIndex((item) => item.id == modalObj.designation.id);
      }

      // var fromDate = null;
      // if(modalObj.userCtcDetails[0].fromDate){
      // var fromDate1 = new Date(modalObj.userCtcDetails[0].fromDate);
      // var fromDate2 = moment(fromDate1, 'YYYY/MM/DD');
      // fromDate = {year:parseInt(fromDate2.format('YYYY')),month:parseInt(fromDate2.format('M')),day:parseInt(fromDate2.format('D'))};
      // }

      // var toDate=null;
      // if(modalObj.userCtcDetails[0].toDate){
      // var toDate1 = new Date(modalObj.userCtcDetails[0].toDate);
      // var toDate2 = moment(toDate1, 'YYYY/MM/DD');
      // toDate = {year:parseInt(toDate2.format('YYYY')),month:parseInt(toDate2.format('M')),day:parseInt(toDate2.format('D'))};
      // }

      var confDate = null;
      var commitmentDate = null;

      if (modalObj.userOfficialDetails) {
        var confDate1 = new Date(modalObj.userOfficialDetails.confirmationDate);
        var confDate2 = moment(confDate1, 'YYYY/MM/DD');
        confDate = { year: parseInt(confDate2.format('YYYY')), month: parseInt(confDate2.format('M')), day: parseInt(confDate2.format('D')) };

        if (modalObj.userOfficialDetails.commitmentDate) {
          var commitmentDate1 = new Date(modalObj.userOfficialDetails.commitmentDate);
          var commitmentDate2 = moment(commitmentDate1, 'YYYY/MM/DD');
          commitmentDate = { year: parseInt(commitmentDate2.format('YYYY')), month: parseInt(commitmentDate2.format('M')), day: parseInt(commitmentDate2.format('D')) };
        }




        if (modalObj.type === "Employee" || modalObj.type === "Consultant") {
          modalObj.userOfficialDetails.serviceVerticle.forEach((serviceVerticle, serviceVerticlKey) => {

            serviceVerticleList.push(serviceVerticle.userServiceVerticle);
          })
          console.log("serviceVerticle patched", serviceVerticleList);


        }

      }
    }


    var reportingManager, reportingPartner, registeredPartner = null;
    if (modalObj.userOfficialDetails) {
      console.log('reportingManager', modalObj.userOfficialDetails.reportingManager);
      console.log('reportingManagerList', this.reportingManagerList);
      if (modalObj.userOfficialDetails.reportingManager) {
        var rManagerIndex, rPartnerIndex = -1;
        rManagerIndex = this.reportingManagerList.findIndex((item) => item.id == modalObj.userOfficialDetails.reportingManager.id);
        // rPartnerIndex = this.reportingPartnerList.findIndex((item) => item.userId == modalObj.userOfficialDetails.reportingPartner.userId);
        if (this.reportingManagerList[rManagerIndex]) {
          reportingManager = this.reportingManagerList[rManagerIndex];
        }
        console.log('reportingManager value for set', reportingManager);
        // && modalObj.userOfficialDetails.reportingPartner
        // if(this.reportingPartnerList[rPartnerIndex]){
        //   reportingPartner = this.reportingPartnerList[rPartnerIndex];
        // }
      }

      if (modalObj.userOfficialDetails.reportingPartners) {
        this.employeeForm.controls['reportingPartners'].clear();
        modalObj.userOfficialDetails.reportingPartners.forEach((partner, key) => {

          let startDate1 = new Date(partner.startDate);
          let startDate2 = moment(startDate1, 'YYYY/MM/DD');
          let startDate = { year: parseInt(startDate2.format('YYYY')), month: parseInt(startDate2.format('M')), day: parseInt(startDate2.format('D')) };

          let endDate1 = new Date(partner.endDate);
          let endDate2 = moment(endDate1, 'YYYY/MM/DD');
          let endDate = { year: parseInt(endDate2.format('YYYY')), month: parseInt(endDate2.format('M')), day: parseInt(endDate2.format('D')) };
          console.log('reportingPartner', partner.reportingPartner);
          console.log('Partner list', this.reportingPartnerList);
          rPartnerIndex = this.reportingPartnerList.findIndex((item) => item.id == partner.reportingPartner.id);
          reportingPartner = this.reportingPartnerList[rPartnerIndex];
          console.log('reporting partner at set time', reportingPartner);
          let partnerFormGroup = this.fb.group({
            id: [partner.id],
            reportingPartner: [reportingPartner, Validators.required],
            startDate: [startDate, Validators.required],
            endDate: [endDate, Validators.required],
          });
          (<FormArray>this.employeeForm.get('reportingPartners')).push(partnerFormGroup);
        })
      }
    }

    if (modalObj.userCtcDetails) {
      console.log("modalObj.userCtcDetails", modalObj.userCtcDetails)
      this.employeeForm.controls['userCtcDetails'].clear();
      modalObj.userCtcDetails.forEach((userCtc, userCtcKey) => {
        let exgratiaMonth
        if (userCtc.exgratiaMonth == 0) {
          exgratiaMonth = ''
        } else {
          exgratiaMonth = userCtc.exgratiaMonth
        }
        let fromDate1 = new Date(userCtc.fromDate);
        let fromDate2 = moment(fromDate1, 'YYYY/MM/DD');
        let fromDate = { year: parseInt(fromDate2.format('YYYY')), month: parseInt(fromDate2.format('M')), day: parseInt(fromDate2.format('D')) };

        let toDate1 = new Date(userCtc.toDate);
        let toDate2 = moment(toDate1, 'YYYY/MM/DD');
        let toDate = { year: parseInt(toDate2.format('YYYY')), month: parseInt(toDate2.format('M')), day: parseInt(toDate2.format('D')) };
        let securityFromDate
        if (userCtc.securityFromDate == null) {
          securityFromDate = ''
        } else {
          let securityFromDate1 = new Date(userCtc.securityFromDate);
          let securityFromDate2 = moment(securityFromDate1, 'YYYY/MM/DD');
          securityFromDate = { year: parseInt(securityFromDate2.format('YYYY')), month: parseInt(securityFromDate2.format('M')), day: parseInt(securityFromDate2.format('D')) };
        }
        let securityToDate
        if (userCtc.securityToDate == null) {
          securityToDate = null
        } else {
          let securityToDate1 = new Date(userCtc.securityToDate);
          let securityToDate2 = moment(securityToDate1, 'YYYY/MM/DD');
          securityToDate = { year: parseInt(securityToDate2.format('YYYY')), month: parseInt(securityToDate2.format('M')), day: parseInt(securityToDate2.format('D')) };
        }

        let loanFromDate
        if (userCtc.loanFromDate == null) {
          loanFromDate = ''
        } else {
          let loanFromDate1 = new Date(userCtc.loanFromDate);
          let loanFromDate2 = moment(loanFromDate1, 'YYYY/MM/DD');
          loanFromDate = { year: parseInt(loanFromDate2.format('YYYY')), month: parseInt(loanFromDate2.format('M')), day: parseInt(loanFromDate2.format('D')) };
        }
        let loanToDate
        if (userCtc.loanToDate == null) {
          loanToDate = null
        } else {
          let loanToDate1 = new Date(userCtc.loanToDate);
          let loanToDate2 = moment(loanToDate1, 'YYYY/MM/DD');
          loanToDate = { year: parseInt(loanToDate2.format('YYYY')), month: parseInt(loanToDate2.format('M')), day: parseInt(loanToDate2.format('D')) };
        }
        let advanceMonth
        if (userCtc.advanceMonth == 0) {
          advanceMonth = ''
        } else {
          advanceMonth = userCtc.advanceMonth
        }
        let recoveryMonth
        if (userCtc.recoveryMonth == 0) {
          recoveryMonth = ''
        } else {
          recoveryMonth = userCtc.recoveryMonth
        }

        console.log("designation list", this.designationList)
        console.log("userCtc.designation", userCtc.designation)
        //var a = this.designationList.indexOf(userCtc.designationId)
        let userCtcFormGroup = this.fb.group({
          ctc: [userCtc.ctc, [Validators.required]],
          basic: [userCtc.basic, [Validators.required]],
          childHostelAllowance: [userCtc.childHostelAllowance],
          variableComponentPercent: [userCtc.variableComponentPercent, [Validators.required]],
          variableComponent: [userCtc.variableComponent],
          uanNo: [userCtc.uanNo, [Validators.required]],
          conveyanceAllowance: [userCtc.conveyanceAllowance, [Validators.required]],
          educationAllowance: [userCtc.educationAllowance, [Validators.required]],
          exgratia: [userCtc.exgratia, [Validators.required]],
          exgratiaMonth: [exgratiaMonth],
          fromDate: [fromDate, [Validators.required]],
          hra: [userCtc.hra, [Validators.required]],
          esic: [userCtc.esic, [Validators.required]],
          medicalAllowance: [userCtc.medicalAllowance, [Validators.required]],
          mobileAllowance: [userCtc.mobileAllowance, [Validators.required]],
          professionalExceptionMonth: [userCtc.professionalExceptionMonth, [Validators.required]],
          professionalExceptionTax: [userCtc.professionalExceptionTax, [Validators.required]],
          professionalTax: [userCtc.professionalTax, [Validators.required]],
          providentFund: [userCtc.providentFund, [Validators.required]],
          securityDeposit: [userCtc.securityDeposit, [Validators.required]],
          securityFromDate: [securityFromDate],
          securityToDate: [securityToDate],
          toDate: [toDate, [Validators.required]],
          loan: [userCtc.loan, [Validators.required]],
          loanFromDate: [loanFromDate],
          loanToDate: [loanToDate],
          emi: [userCtc.emi, [Validators.required]],
          advance: [userCtc.advance, [Validators.required]],
          advanceMonth: [advanceMonth],
          recoveryOrExpenses: [userCtc.recoveryOrExpenses, [Validators.required]],
          recoveryMonth: [recoveryMonth],
          designation: [userCtc.designation, [Validators.required]],
          overtimeApplicability: [userCtc.overtimeApplicability, [Validators.required]],
          epfApplicable: [userCtc.epfApplicable, [Validators.required]],
          laptopEligibility: [userCtc.laptopEligibility, [Validators.required]],
          userCtcTds: this.fb.array([]),
        });

        if (userCtc.userCtcTds.length > 0) {
          (<FormArray>userCtcFormGroup.controls['userCtcTds']).clear();
          userCtc.userCtcTds.forEach((userCtcTds, userCtcTdsKey) => {
            let tdsFromDate1 = new Date(userCtcTds.fromDate);
            let tdsFromDate2 = moment(tdsFromDate1, 'YYYY/MM/DD');
            let tdsFromDate = { year: parseInt(tdsFromDate2.format('YYYY')), month: parseInt(tdsFromDate2.format('M')), day: parseInt(tdsFromDate2.format('D')) };

            let tdsToDate1 = new Date(userCtcTds.toDate);
            let tdsToDate2 = moment(tdsToDate1, 'YYYY/MM/DD');
            let tdsToDate = { year: parseInt(tdsToDate2.format('YYYY')), month: parseInt(tdsToDate2.format('M')), day: parseInt(tdsToDate2.format('D')) };

            let userCtcTdsFormGroup = this.fb.group({
              tds: [userCtcTds.tds],
              fromDate: [tdsFromDate],
              toDate: [tdsToDate],
            });

            (<FormArray>userCtcFormGroup.controls['userCtcTds']).push(userCtcTdsFormGroup);
          })
        }

        (<FormArray>this.employeeForm.get('userCtcDetails')).push(userCtcFormGroup);
        console.log("userCtcDetails", this.employeeForm.get('userCtcDetails'))
      })
    }
    console.log('modalObj.userExitDetails', modalObj.userExitDetails);
    if (modalObj.userExitDetails) {
      if (modalObj.userExitDetails.id) {
        this.showEmployeeExitDetails = true;

        let exitDate1 = new Date(modalObj.userExitDetails.exitDate);
        let exitDate2 = moment(exitDate1, 'YYYY/MM/DD');
        let exitDate = { year: parseInt(exitDate2.format('YYYY')), month: parseInt(exitDate2.format('M')), day: parseInt(exitDate2.format('D')) };

        this.employeeForm.controls['userExitDetails'].patchValue({
          dataCard: modalObj.userExitDetails.dataCard,
          exitDate: exitDate,
          exitForm: modalObj.userExitDetails.exitForm,
          exitReason: modalObj.userExitDetails.exitReason,
          idCard: modalObj.userExitDetails.idCard,
          laptop: modalObj.userExitDetails.laptop,
          officialDocument: modalObj.userExitDetails.officialDocument,
          otherHardware: modalObj.userExitDetails.otherHardware,
          penDrvie: modalObj.userExitDetails.penDrvie,
          remark: modalObj.userExitDetails.remark,
        });
      }
    } else {
      this.showEmployeeExitDetails = false;
    }

    if (modalObj.userOfficialDetails) {
      console.log('registered partner list', this.registerPartnerList);
      console.log('registeredPartner', modalObj.userOfficialDetails.registeredPartner);
      if (modalObj.userOfficialDetails.registeredPartner) {
        var regPartnerIndex = this.registerPartnerList.findIndex((item) => item.id == modalObj.userOfficialDetails.registeredPartner.id);
        registeredPartner = this.registerPartnerList[regPartnerIndex];
      }
      console.log('registeredPartner value for set', registeredPartner);
      var icaiRegistrationDate
      if (modalObj.userOfficialDetails.icaiRegistrationDate) {
        var date1 = new Date(modalObj.userOfficialDetails.icaiRegistrationDate);
        var date2 = moment(date1, 'YYYY/MM/DD');
        icaiRegistrationDate = { year: parseInt(date2.format('YYYY')), month: parseInt(date2.format('M')), day: parseInt(date2.format('D')) };
      }

    }

    var membershipDate = null;
    if (modalObj.userOfficialDetails.dateOfMembershipNumber) {
      var membershipDate1 = new Date(modalObj.userOfficialDetails.dateOfMembershipNumber);
      var membershipDate2 = moment(membershipDate1, 'YYYY/MM/DD');
      membershipDate = { year: parseInt(membershipDate2.format('YYYY')), month: parseInt(membershipDate2.format('M')), day: parseInt(membershipDate2.format('D')) };
    }

    var bankAccountName = '';
    var newBankAccountName = '';
    if (modalObj.userOfficialDetails.bankAcountName === 'ICICI') {

      bankAccountName = modalObj.userOfficialDetails.bankAcountName;
      newBankAccountName = '';
    } else {

      bankAccountName = 'Other Bank';
      newBankAccountName = modalObj.userOfficialDetails.bankAcountName;
    }

    this.empType = modalObj.type;

    console.log('reportingpartner before patchvalue', registeredPartner);
    console.log('reportingManager value patch', reportingManager);
    console.log('reportingPartner value patch', reportingPartner);
    if (modalObj.userPersonalDetails == null) {
      this.employeeForm.patchValue({
        id: modalObj.id,
        userId: modalObj.userId,
        firstName: modalObj.firstName,
        middleName: modalObj.middleName,
        lastName: modalObj.lastName,
        // password: '',
        // Personal Details
        email: modalObj.email,
        dateOfBirth: dob,
        // bloodGroup: modalObj.userPersonalDetails.bloodGroup,
        // panNumber: modalObj.userPersonalDetails.panNumber,
        // aadharNumber: modalObj.userPersonalDetails.aadharNumber,
        qualification: modalObj.userPersonalDetails.qualification,
        // // certification:  modalObj.userPersonalDetails.certification,
        // gender: modalObj.userPersonalDetails.gender,
        // profileStatus: modalObj.userOfficialDetails.profileStatus,
        // personalEmail: modalObj.userPersonalDetails.personalEmail,
        // officalMobileNumber: modalObj.userPersonalDetails.officalMobileNumber,
        // contactMobileNumber: modalObj.userPersonalDetails.contactMobileNumber,
        // // landlineStdCode: modalObj.userPersonalDetails.landlineStdCode,
        // // landlineNumber: modalObj.userPersonalDetails.landlineNumber,
        // emergencyContactNumber1: modalObj.userPersonalDetails.emergencyContactNumber1,
        // emergencyContactName1: modalObj.userPersonalDetails.emergencyContactName1,
        // emergencyContactRelation1: modalObj.userPersonalDetails.emergencyContactRelation1,
        // emergencyContactNumber2: modalObj.userPersonalDetails.emergencyContactNumber2,
        // emergencyContactName2: modalObj.userPersonalDetails.emergencyContactName2,
        // emergencyContactRelation2: modalObj.userPersonalDetails.emergencyContactRelation2,
        // Official Details
        branch: this.branchList[branchIndex],
        droles: modalObj.droles,
        designation: this.designationList[designationIndex],
        reportingManager: reportingManager,
        reportingPartner: reportingPartner,
        joiningDate: joiningDate,
        membershipNumber: modalObj.userOfficialDetails.membershipNumber,
        dateOfMembershipNumber: membershipDate,
        probabtionPeriod: modalObj.userOfficialDetails.probabtionPeriod,
        // articleTrainingLimit: modalObj.userOfficialDetails.articleTrainingLimit,
        verified: modalObj.userOfficialDetails.verified,
        confirmationDate: confDate,
        commitmentDate: commitmentDate,
        verificationSource: modalObj.userOfficialDetails.verificationSource,
        remark: modalObj.userOfficialDetails.remark,
        laptopServiceTagNumber: modalObj.userOfficialDetails.laptopServiceTagNumber,
        scholarship: modalObj.userOfficialDetails.scholarship,
        // dataCardNumber: modalObj.userOfficialDetails.dataCardNumber,
        bankAcountName: bankAccountName,
        newBankAcountName: newBankAccountName,
        bankAccountNumber: modalObj.userOfficialDetails.bankAccountNumber,
        bankIfscCode: modalObj.userOfficialDetails.bankIfscCode,

        icaiRegistrationDate: icaiRegistrationDate,
        icaiRegistrationNumber: modalObj.userOfficialDetails.icaiRegistrationNumber,
        articleshipEndDate: articleshipEndDate,
        registeredPartner: registeredPartner,
        clients: modalObj.userOfficialDetails.clients,
        certificationType: userCertifications,
        userQualifications: userQualifications,
        description: description

      });
    } else {
      this.employeeForm.patchValue({
        id: modalObj.id,
        userId: modalObj.userId,
        firstName: modalObj.firstName,
        middleName: modalObj.middleName,
        lastName: modalObj.lastName,
        // password: '',
        // Personal Details
        email: modalObj.email,
        dateOfBirth: dob,
        bloodGroup: modalObj.userPersonalDetails.bloodGroup,
        panNumber: modalObj.userPersonalDetails.panNumber,
        aadharNumber: modalObj.userPersonalDetails.aadharNumber,
        qualification: modalObj.userPersonalDetails.qualification,
        // certification:  modalObj.userPersonalDetails.certification,
        gender: modalObj.userPersonalDetails.gender,
        profileStatus: modalObj.userOfficialDetails.profileStatus,
        personalEmail: modalObj.userPersonalDetails.personalEmail,
        officalMobileNumber: modalObj.userPersonalDetails.officalMobileNumber,
        contactMobileNumber: modalObj.userPersonalDetails.contactMobileNumber,
        // landlineStdCode: modalObj.userPersonalDetails.landlineStdCode,
        // landlineNumber: modalObj.userPersonalDetails.landlineNumber,
        emergencyContactNumber1: modalObj.userPersonalDetails.emergencyContactNumber1,
        emergencyContactName1: modalObj.userPersonalDetails.emergencyContactName1,
        emergencyContactRelation1: modalObj.userPersonalDetails.emergencyContactRelation1,
        emergencyContactNumber2: modalObj.userPersonalDetails.emergencyContactNumber2,
        emergencyContactName2: modalObj.userPersonalDetails.emergencyContactName2,
        emergencyContactRelation2: modalObj.userPersonalDetails.emergencyContactRelation2,
        // Official Details
        branch: this.branchList[branchIndex],
        droles: modalObj.droles,
        designation: this.designationList[designationIndex],
        reportingManager: reportingManager,
        reportingPartner: reportingPartner,
        joiningDate: joiningDate,
        membershipNumber: modalObj.userOfficialDetails.membershipNumber,
        dateOfMembershipNumber: membershipDate,
        probabtionPeriod: modalObj.userOfficialDetails.probabtionPeriod,
        // articleTrainingLimit: modalObj.userOfficialDetails.articleTrainingLimit,
        verified: modalObj.userOfficialDetails.verified,
        confirmationDate: confDate,
        commitmentDate: commitmentDate,
        verificationSource: modalObj.userOfficialDetails.verificationSource,
        remark: modalObj.userOfficialDetails.remark,
        laptopServiceTagNumber: modalObj.userOfficialDetails.laptopServiceTagNumber,
        scholarship: modalObj.userOfficialDetails.scholarship,
        // dataCardNumber: modalObj.userOfficialDetails.dataCardNumber,
        bankAcountName: bankAccountName,
        newBankAcountName: newBankAccountName,
        bankAccountNumber: modalObj.userOfficialDetails.bankAccountNumber,
        bankIfscCode: modalObj.userOfficialDetails.bankIfscCode,

        icaiRegistrationDate: icaiRegistrationDate,
        icaiRegistrationNumber: modalObj.userOfficialDetails.icaiRegistrationNumber,
        articleshipEndDate: articleshipEndDate,
        registeredPartner: registeredPartner,
        clients: modalObj.userOfficialDetails.clients,
        certificationType: userCertifications,
        userQualifications: userQualifications,
        serviceVerticle: serviceVerticleList,
        description: description

      });
    }

    console.log('employee form after patchvalue', this.employeeForm);

    if (modalObj.type == "Article") {
      // this.employeeForm.controls.droles.setValue(modalObj.articleType)
      this.employeeForm.controls.articleType.setValue(modalObj.userOfficialDetails.articleType);
    }

    if (modalObj.addresses.length > 0) {
      var pIndex = modalObj.addresses.findIndex(item => item.type === "permanent");
      var lIndex = modalObj.addresses.findIndex(item => item.type === "local");
      var pAddress;
      if (pIndex >= 0) {
        pAddress = modalObj.addresses[pIndex];
        var permanentStateIndex = -1;
        if (modalObj.addresses[pIndex].state) {
          permanentStateIndex = this.stateList.findIndex((item) => item.id == modalObj.addresses[pIndex].state.id);
        }
        this.employeeForm.controls['permanentAddress'].patchValue({
          address: modalObj.addresses[pIndex].address,
          city: modalObj.addresses[pIndex].city,
          state: this.stateList[permanentStateIndex],
          postalCode: modalObj.addresses[pIndex].postalCode,
          country: modalObj.addresses[pIndex].country,
          streetName: modalObj.addresses[pIndex].streetName,
          type: "permanent"
        });
      }
      if (pAddress.city == null) {
        this.showPermanentCity = true;
      }
      if (pAddress.postalCode == null) {
        this.showPermanentPostCode = true;
      }
      var lAddress;
      if (lIndex >= 0) {
        lAddress = modalObj.addresses[lIndex];
        var localStateIndex = -1;
        if (modalObj.addresses[lIndex].state) {
          localStateIndex = this.stateList.findIndex((item) => item.id == modalObj.addresses[lIndex].state.id);
        }

        console.log('modal obj address :', modalObj.addresses[lIndex].address);
        console.log('modal obj city :', modalObj.addresses[lIndex].city);
        console.log('modal obj postalCode :', modalObj.addresses[lIndex].postalCode);

        this.employeeForm.controls['localAddress'].patchValue({
          address: modalObj.addresses[lIndex].address,
          city: modalObj.addresses[lIndex].city,
          state: this.stateList[localStateIndex],
          postalCode: modalObj.addresses[lIndex].postalCode,
          country: modalObj.addresses[lIndex].country,
          streetName: modalObj.addresses[lIndex].streetName,
          type: "local"
        })
      }
      if (lAddress != undefined) {
        if (lAddress.city == null) {
          this.showLocalCity = true;
        }
        if (lAddress.postalCode == null) {
          this.showLocalPostCode = true;
        }
      }
      const local = this.employeeForm.controls['localAddress'].value;
      this.oldLocalAddress = local;
      const permanent = this.employeeForm.controls['permanentAddress'].value;

      this.isSameAddress =
        permanent.address === local.address &&
        permanent.city.id === local.city.id &&
        permanent.state.id === local.state.id &&
        permanent.postalCode.id === local.postalCode.id &&
        permanent.country === local.country &&
        permanent.streetName === local.streetName;
      this.employeeForm.get('sameAsPermanent')?.setValue(this.isSameAddress);
    }

    this.onChangeEmployeeType();
    this.onChangeArticleType();
    this.openModal('edit');
    // onChange();
    this.isPartner = false;
    for (let i = 0; i < this.employeeForm.controls.droles.value.length; i++) {
      if (['Partner', 'Managing Partner', 'Designated Partner'].includes(this.employeeForm.controls.droles.value[i].name)) {
        this.isPartner = true;
        this.employeeForm.controls.reportingPartners.clear();
      }
    }
  }
  ///---------------------------------------------------------
  @ViewChild('viewModalContent') private viewModalContent;
  openViewModal() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "animate__animated animate__slideInUp animate__faster",
      backdrop: 'static',
      keyboard: false
    }
    this.modalStatus = status;
    this.modalService.open(this.viewModalContent, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed`;
    });
  }

  userCTCDetails;
  selectedEmployeeForView;
  onViewEmpType;
  onViewClick(formObj) {
    this.onViewEmpType = formObj.type
    console.log('onviewEmpType', this.onViewEmpType);
    this.userCTCDetails = 0;
    this.selectedEmployeeForView = formObj;
    console.log("selectedEmployeeForView", this.selectedEmployeeForView);
    if (this.selectedEmployeeForView.userCtcDetails.length > 0) {
      var lastIndex = this.selectedEmployeeForView.userCtcDetails.length - 1;
      this.selectedEmployeeForView.userCtcDetails.forEach((element, index) => {
        if (index == lastIndex) {
          // this.userCTCDetails = (element.basic + element.childHostelAllowance +
          //   element.conveyanceAllowance + element.medicalAllowance +
          //   element.educationAllowance + element.hra + element.mobileAllowance
          //   + element.providentFund) ;
          console.log('element for ctc fromDate', element.fromDate);
          this.userCTCDetails = this.getTotalAmount(element);
        }
      });
    }
    this.openViewModal();
  }
  //------------------------------
  @ViewChild('userCtcModalContent') private userCtcModalContent;
  ctcModalReference: NgbModalRef;
  openUserCtcModal() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      windowClass: "animate__animated animate__slideInUp animate__faster",
      backdrop: 'static',
      keyboard: false
    }
    // this.modalStatus = status;
    this.ctcModalReference = this.modalService.open(this.userCtcModalContent, ngbModalOptions)
    // .result.then((result) => {
    //    this.closeResult = `Closed with: ${result}`;
    //  }, (reason) => {
    //    this.closeResult = `Dismissed`;
    //  });
  };

  addCtcDetailsBtnClick() {
    this.ctcModalStatus = 'add';
    this.resetCTCForm();
    this.initializeCTCForm();
    this.openUserCtcModal();
  }

  initializeCTCForm() {
    let secFromDate: any = '';
    let secToDate: any = '';
    // var today = new Date();
    // var formattedTodayDate = moment(today, 'MM/DD/YYYY');
    // var confirmationDate = new Date(this.employeeForm.value.confirmationDate.year + '-' + this.employeeForm.value.confirmationDate.month + '-' + this.employeeForm.value.confirmationDate.day);
    // var formattedConfirmationDate = moment(confirmationDate, 'MM/DD/YYYY');
    // console.log('today & confirmation date',today, " ", confirmationDate);
    // console.log('today & confirmation dateformated',formattedConfirmationDate, " ", formattedTodayDate);
    // console.log(formattedConfirmationDate > formattedTodayDate)

    // && formattedConfirmationDate > formattedTodayDate

    if (this.empType != 'Article') {
      secFromDate = this.employeeForm.value.joiningDate;
      // secToDate = this.employeeForm.value.confirmationDate;
      secToDate = this.calculateSecurityToDate(this.employeeForm.value.joiningDate);

      console.log('security form date', secFromDate, this.employeeForm.value.joiningDate);
      console.log('security to date', secToDate, this.employeeForm.value.confirmationDate);
    } else {
      secFromDate = ''
      secToDate = ''
    }
    this.ctcForm.patchValue({
      basic: 0,
      childHostelAllowance: 0,
      variableComponentPercent: 0,
      variableComponent: 0,
      uanNo: 0,
      conveyanceAllowance: 0,
      educationAllowance: 0,
      exgratia: 0,
      exgratiaMonth: '',
      fromDate: '',
      hra: 0,
      medicalAllowance: 0,
      mobileAllowance: 0,
      professionalExceptionMonth: 2,
      professionalExceptionTax: 300,
      professionalTax: 200,
      providentFund: 0,
      securityDeposit: 0,
      securityFromDate: secFromDate,
      securityToDate: secToDate,
      designation: '',
      overtimeApplicability: null,
      toDate: '',
      advance: 0,
      advanceMonth: '',
      recoveryOrExpenses: 0,
      recoveryMonth: '',
      loan: 0,
    });
    this.addCtcTdsButtonClick();
  }

  onProfessionalExceptionMonthChange() {
    console.log("exception month :", this.ctcForm.controls.professionalExceptionMonth.value)
    if (this.ctcForm.controls.professionalExceptionMonth.value == '2') {
      this.ctcForm.patchValue({
        professionalExceptionTax: 300,
      })
    } else if (this.ctcForm.controls.professionalExceptionMonth.value == null || this.ctcForm.controls.professionalExceptionMonth.value == '' || this.ctcForm.controls.professionalExceptionMonth.value == undefined) {
      this.ctcForm.patchValue({
        professionalExceptionTax: '',
      })
    } else {
      this.ctcForm.patchValue({
        professionalExceptionTax: 200,
      })
    }
  }

  validateFromAndToDate() {
    var isValid = false;
    console.log("ctcForm", this.ctcForm)
    console.log("ctcArray", this.employeeForm.get('userCtcDetails'))
    for (let i = 0; i < this.employeeForm.get('userCtcDetails').value.length; i++) {
      var ctcDetailsFromDate = new Date(this.employeeForm.get('userCtcDetails').value[i].fromDate.year + '/' + this.employeeForm.get('userCtcDetails').value[i].fromDate.month + '/' + this.employeeForm.get('userCtcDetails').value[i].fromDate.day)
      var formattedCtcDetailsFromDate = moment(ctcDetailsFromDate).format('DD/MM/YYYY');
      var ctcDetailsToDate = new Date(this.employeeForm.get('userCtcDetails').value[i].toDate.year + '/' + this.employeeForm.get('userCtcDetails').value[i].toDate.month + '/' + this.employeeForm.get('userCtcDetails').value[i].toDate.day)
      var formattedCtcDetailsToDate = moment(ctcDetailsToDate).format('DD/MM/YYYY');
      var ctcFromDate = new Date(this.ctcForm.value.fromDate.year + '/' + this.ctcForm.value.fromDate.month + '/' + this.ctcForm.value.fromDate.day)
      var formattedCtcFromDate = moment(ctcFromDate).format('DD/MM/YYYY');
      var ctcToDate = new Date(this.ctcForm.value.toDate.year + '/' + this.ctcForm.value.toDate.month + '/' + this.ctcForm.value.toDate.day)
      var formattedCtcToDate = moment(ctcToDate).format('DD/MM/YYYY');
      console.log("formattedCtcFromDate", ctcFromDate);
      console.log("formattedCtcDetailsFromDate", ctcDetailsFromDate);
      console.log("formattedCtcToDate", ctcDetailsToDate);
      console.log("formattedCtcDetailsToDate", ctcToDate);
      console.log("first condition", ctcFromDate >= ctcDetailsFromDate)
      console.log("secound condition", ctcDetailsToDate >= ctcToDate)
      console.log("------------------------------------------------------------------")

      if ((ctcFromDate >= ctcDetailsFromDate) && (ctcDetailsToDate >= ctcToDate)) {
        isValid = true;
      } else if (ctcFromDate >= ctcDetailsFromDate && ctcDetailsToDate >= ctcFromDate) {
        isValid = true;
      } else if (ctcToDate >= ctcDetailsFromDate && ctcDetailsToDate >= ctcFromDate) {
        isValid = true;
      }
      console.log("isValid", isValid)
    }
    return isValid;
  }

  myForm2: any;
  addCTCToProfile() {
    this.ctcFormSubmitted = true;
    this.ctcForm.controls.securityFromDate.setErrors(null);
    this.ctcForm.controls.securityToDate.setErrors(null);
    this.ctcForm.controls.mobileAllowance.clearValidators();
    console.log("this.ctcForm.valid", this.ctcForm.controls)
    this.ctcForm.patchValue({
      mobileAllowance: this.ctcForm.value.mobileAllowance == null ? 0 : this.ctcForm.value.mobileAllowance
    })
    console.log("this.ctcForm.value.mobileAllowance", this.ctcForm.value.mobileAllowance);
    this.validateUanNumber();
    this.logValidationErrorsForCtc(this.ctcForm);
    if (this.ctcForm.valid && !this.validateFromAndToDate()) {
      // if (this.ctcForm.valid) {
      var designation = ''
      var designationIndex = -1;
      if (this.ctcForm.value.designation) {
        designationIndex = this.designationList.findIndex((item) => item.id == this.ctcForm.value.designation);
      }
      this.ctcForm.patchValue({
        designation: this.designationList[designationIndex]
      })
      // const clonedForm = _.cloneDeep(this.ctcForm);
      // (<FormArray>this.employeeForm.get('userCtcDetails')).push(<FormGroup>clonedForm);
      const clonedForm = this.fb.group(this.ctcForm.getRawValue());
      (this.employeeForm.get('userCtcDetails') as FormArray).push(clonedForm);
      console.log("clonedForm Mobile", clonedForm.value.mobileAllowance);
      var designationEmployeeForm
      designationEmployeeForm = this.getDesignationPerCurrentDate(this.employeeForm.value.userCtcDetails)
      console.log("getDesignationPerCurrentDate", designationEmployeeForm)
      if (designationEmployeeForm != '') {
        var designationIndex = -1;
        if (designationEmployeeForm != '') {
          designationIndex = this.designationList.findIndex((item) => item.id == designationEmployeeForm.id);
        }
        this.employeeForm.patchValue({
          designation: this.designationList[designationIndex]
        })
      }
      this.ctcModalReference.close();
    } else {
      if (!this.ctcForm.valid) {
        this.commonMessageService.swalAlertWithoutIcon('', "please check form errors")
      }
      else {
        this.commonMessageService.swalAlertWithoutIcon('', "Ctc between this date range has been created already...! ")
      }
    }
  }

  removeCtcFromProfile(index: number): void {
    const formArray = <FormArray>this.employeeForm.get('userCtcDetails');
    formArray.removeAt(index);
    formArray.markAsDirty();
    formArray.markAsTouched();
  }

  // EDIT CTC
  ctcIndex;
  ctcModalStatus = 'add';
  setObjectToCtcModal() {
    var securityToDate = null;
    var securityFromDate = null;
    if (this.employeeForm.get('userCtcDetails').value[this.ctcIndex].securityFromDate == "" ||
      this.employeeForm.get('userCtcDetails').value[this.ctcIndex].securityFromDate == null) {
      console.log('inside condition if');
      securityFromDate = this.employeeForm.value.joiningDate;
    } else {
      securityFromDate = this.employeeForm.get('userCtcDetails').value[this.ctcIndex].securityFromDate;
    }
    if (this.employeeForm.get('userCtcDetails').value[this.ctcIndex].securityToDate == "" ||
      this.employeeForm.get('userCtcDetails').value[this.ctcIndex].securityToDate == null) {
      console.log('inside condition if');
      securityToDate = this.employeeForm.value.confirmationDate;
    } else {
      securityToDate = this.employeeForm.get('userCtcDetails').value[this.ctcIndex].securityToDate;
    }
    console.log('setting CTC modal', this.employeeForm.get('userCtcDetails').value[this.ctcIndex]);
    this.ctcForm = this.fb.group({
      ctc: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].ctc, [Validators.required]],
      basic: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].basic, [Validators.required]],
      childHostelAllowance: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].childHostelAllowance],
      variableComponent: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].variableComponent],
      variableComponentPercent: Number(this.employeeForm.get('userCtcDetails').value[this.ctcIndex].variableComponentPercent),
      uanNo: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].uanNo, [Validators.required]],
      conveyanceAllowance: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].conveyanceAllowance, [Validators.required]],
      // educationAllowance: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].educationAllowance, [Validators.required]],
      exgratia: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].exgratia, [Validators.required]],
      exgratiaMonth: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].exgratiaMonth],
      fromDate: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].fromDate, [Validators.required]],
      hra: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].hra, [Validators.required]],
      medicalAllowance: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].medicalAllowance, [Validators.required]],
      mobileAllowance: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].mobileAllowance, [Validators.required]],
      esic: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].esic, [Validators.required]],
      professionalExceptionMonth: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].professionalExceptionMonth, [Validators.required]],
      professionalExceptionTax: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].professionalExceptionTax, [Validators.required]],
      professionalTax: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].professionalTax, [Validators.required]],
      providentFund: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].providentFund, [Validators.required]],
      securityDeposit: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].securityDeposit, [Validators.required]],
      securityFromDate: [securityFromDate],
      securityToDate: [securityToDate],
      toDate: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].toDate, [Validators.required]],
      loan: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].loan, [Validators.required]],
      loanFromDate: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].loanFromDate],
      loanToDate: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].loanToDate],
      emi: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].emi, [Validators.required]],
      advance: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].advance, [Validators.required]],
      advanceMonth: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].advanceMonth],
      recoveryOrExpenses: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].recoveryOrExpenses, [Validators.required]],
      recoveryMonth: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].recoveryMonth],
      designation: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].designation.id, [Validators.required]],
      overtimeApplicability: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].overtimeApplicability || false, [Validators.required]],
      laptopEligibility: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].laptopEligibility, [Validators.required]],
      epfApplicable: [this.employeeForm.get('userCtcDetails').value[this.ctcIndex].epfApplicable || false],
      userCtcTds: this.fb.array([]),
    })

    // const epf = this.ctcForm.get('epfApplicable')?.value;

    // if (epf === false) {
    //   this.ctcForm.get('providentFund')?.disable();
    // }
    const ctcData = (this.employeeForm.get('userCtcDetails') as FormArray)
      .getRawValue()[this.ctcIndex];
    if (!Array.isArray(ctcData.userCtcTds)) {
      ctcData.userCtcTds = ctcData.userCtcTds ? [ctcData.userCtcTds] : [];
    }
    const ctcTdsLength = ctcData.userCtcTds?.length;
    console.log("CTC DATA : ", ctcData);
    // var ctcTdsLength = this.employeeForm.get('userCtcDetails').value[this.ctcIndex].userCtcTds.length
    console.log("ctcTdsLength", ctcTdsLength);
    if (ctcTdsLength > 0) {
      // (<FormArray>this.ctcForm.controls['userCtcTds']).clear()
      (this.ctcForm.controls['userCtcTds'] as FormArray).clear();
      // this.employeeForm.get('userCtcDetails').value[this.ctcIndex].userCtcTds.forEach(userCtcTds => {
      //   let userCtcTdsFormGroup = this.fb.group({
      //     tds: [userCtcTds.tds],
      //     fromDate: [userCtcTds.fromDate],
      //     toDate: [userCtcTds.toDate],
      //   });
      ctcData.userCtcTds.forEach(userCtcTds => {
        let userCtcTdsFormGroup = this.fb.group({
          tds: [userCtcTds.tds],
          fromDate: [userCtcTds.fromDate],
          toDate: [userCtcTds.toDate],
        });
        console.log('TDS FORM GROUP:', userCtcTdsFormGroup);
        // (<FormArray>this.ctcForm.controls['userCtcTds']).push(userCtcTdsFormGroup);
        (this.ctcForm.controls['userCtcTds'] as FormArray)
          .push(userCtcTdsFormGroup);
      })
      this.listenToCtcChangesForPfApplicable();
      this.initializeCtcFormChangeSubscription();
      // this.listenToCtcInput();
    } else {
      this.addCtcTdsButtonClick();
    }
    console.log("ctcForm", this.ctcForm)
    // this.employeeForm.get('userCtcDetails').value[this.ctcIndex].ctcDesignation = designation.id
    // console.log("this.employeeForm",this.employeeForm.get('userCtcDetails').value[this.ctcIndex])
    // var arrayControl = this.employeeForm.get('userCtcDetails') as FormArray;
    // console.log("arrayControl",arrayControl.at(this.ctcIndex))
    // this.ctcForm = this.employeeForm.get('userCtcDetails').value[this.ctcIndex];
    this.openUserCtcModal();

  }

  editCtcInProfile(index: number) {
    this.ctcIndex = index;
    this.ctcModalStatus = 'edit';
    this.resetCTCForm();
    this.setObjectToCtcModal();

  }

  updateCTCToProfile() {
    this.ctcFormSubmitted = true;
    console.log("this.ctcForm.update", this.ctcForm.controls)
    this.ctcForm.controls.securityFromDate.setErrors(null);
    this.ctcForm.controls.securityToDate.setErrors(null);
    this.ctcForm.controls.loanFromDate.setErrors(null);
    this.ctcForm.controls.loanToDate.setErrors(null);

    this.ctcForm.controls.mobileAllowance.clearValidators();
    console.log("this.ctcForm.valid", this.ctcForm.controls)
    this.ctcForm.patchValue({
      mobileAllowance: this.ctcForm.value.mobileAllowance == null ? 0 : this.ctcForm.value.mobileAllowance
    })

    this.validateUanNumber();
    this.logValidationErrorsForCtc(this.ctcForm);
    if (this.ctcForm.valid) {
      this.removeCtcFromProfile(this.ctcIndex);
      if (!this.validateFromAndToDate()) {
        console.log("removeCtcFromProfile", this.employeeForm.get('userCtcDetails'))
        console.log("ctc index", this.ctcForm.value.designation)

        var designation = ''
        var designationIndex = -1;
        if (this.ctcForm.value.designation) {
          designationIndex = this.designationList.findIndex((item) => item.id == this.ctcForm.value.designation);
        }
        console.log("designation", this.designationList[designationIndex])
        this.ctcForm.patchValue({
          designation: this.designationList[designationIndex]
        })
        console.log("this.ctcForm", this.ctcForm)

        const clonedForm = _.cloneDeep(this.ctcForm);
        (<FormArray>this.employeeForm.get('userCtcDetails')).insert(this.ctcIndex, clonedForm);
        console.log("afterUpdate", this.employeeForm.get('userCtcDetails'))

        var designationEmployeeForm
        designationEmployeeForm = this.getDesignationPerCurrentDate(this.employeeForm.value.userCtcDetails)
        console.log("getDesignationPerCurrentDate", designationEmployeeForm)
        if (designationEmployeeForm != '') {
          console.log("in if")
          var designationIndex = -1;
          if (designationEmployeeForm != '') {
            designationIndex = this.designationList.findIndex((item) => item.id == designationEmployeeForm.id);
          }
          this.employeeForm.patchValue({
            designation: this.designationList[designationIndex]
          })
        }
        this.ctcModalReference.close();
      } else {
        this.commonMessageService.swalAlertWithoutIcon('', "Ctc between this date range has been created already...! ")
      }
    } else {
      this.commonMessageService.swalAlertWithoutIcon('', "please check form errors")
    }
  }
  //------- ADD EXIT DETAILS ------------------------------
  showEmployeeExitDetails = false;
  toggleExitDetailsBtnClick() {
    this.showEmployeeExitDetails = !this.showEmployeeExitDetails;
  }
  ///---------------------------------------------------------
  @ViewChild('userProfileModalContent') private userProfileModalContent;
  openUserProfileModal() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      windowClass: "animate__animated animate__slideInUp animate__faster",
      backdrop: 'static',
      keyboard: false
    }
    // this.modalStatus = status;
    this.modalService.open(this.userProfileModalContent, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed`;
    });
  };
  //userDocumentTypeList=["photo","pan","aadhar","Professional NDA", "Appointment letter", "Membership certificate", "Salary slip", "Relieving letter", "Last appointment letter"]
  /*  userDocumentTypeList=["Passport Photo","Resume","PAN Card","Aadhar Card","Professional NDA","Graduation Marksheet",
   "Employee Questionnaire","Article Questionnaire","10th Marksheet","Other Documents","Consultant Agreement","Non Disclosure Agreement",
   "12th Marksheet", "IPCC Marksheet","Commitment Letter","Appointment letter","Appointment Letter from Previous Employer",
   "Relieving or Experience Letter from Previous Employer","Salary slip from Previous Employer", "Membership certificate", "Salary slip",
    "Relieving letter","Membership Certificate or Member Card","CA Marksheet","Orientation Certificate","ITT Certificate",
   "Last appointment letter","Appointment Letter"]  */
  // getUserDocumentTypeList(designation) {
  //   this.masterDataService.getDocumentUploadType(designation)
  //     .subscribe(resp => {
  //       this.userDocumentTypeList = resp;
  //     })
  // }

  selectedUserDocumentUpload;
  documentType = "";
  isFileValid = true;
  onUploadUserDocumentClick(formObj) {
    console.log('onUploadUserDocumentClick formObj', formObj)
    this.selectedUserDocumentUpload = formObj;
    this.documentType = "";
    // this.getUserDocumentTypeList(this.selectedUserDocumentUpload.type);
    this.getUserDocumentList();
    this.openUserProfileModal();
  };

  imageName;
  userDocumentTypeList: any;
  getUserDocumentList() {
    this.masterDataService.getDocumentUploadList(this.selectedUserDocumentUpload.userId).subscribe((resp: any) => {
      console.log('response', resp);
      this.userDocumentTypeList = resp;
      for (var i = 0; i < this.userDocumentTypeList.length; i++) {
        if (this.userDocumentTypeList[i].url != null) {
          this.imageName = this.userDocumentTypeList[i].url.replace(/^.*[\\\/]/, '');
          this.userDocumentTypeList[i]["imageName"] = this.imageName;
        }
      }
    });
  }

  myFiles = [];
  docStatus = [];
  docType = [];
  fileChange(event, document) {
    for (var i = 0; i < this.myFiles.length; i++) {
      if (this.myFiles[i].fileName === document.type) {
        this.myFiles.splice(i, 1);
      }
    }

    for (var i = 0; i < this.docType.length; i++) {
      if (this.docType[i] === document.type) {
        this.docType.splice(i, 1);
      }
    }

    for (var i = 0; i < event.target.files.length; i++) {
      this.myFiles.push(event.target.files[i]);
    }

    this.myFiles[this.myFiles.length - 1]["fileName"] = document.type;
    this.docStatus.push(document.required);
    this.docType.push(document.type);
    console.log('docStauts', this.docStatus);
    console.log('docType', this.docType);
    console.log('myfiles array', this.myFiles);
  }

  onUploadClick() {
    const formData = new FormData();
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append('files', this.myFiles[i]);
    }
    console.log('formdatagetAll', formData.getAll('files'));

    this.humanResourceService.uploadUserDocumentList(formData, this.selectedUserDocumentUpload.userId, this.docStatus, this.docType)
      .subscribe(
        resp => {
          if (resp.operationName == 'SUCCESS') {
            this.myFiles = [];
            this.docStatus = [];
            this.docType = [];
            this.closeModal();
            this.commonMessageService.swalAlertWithIcon('', 'Uploaded Successfully!', 'success');
          } else {
            this.commonMessageService.swalAlertWithIcon('', resp.operationResult || 'File upload failed!', 'error');
          }

        });
  }


  @ViewChild('userDocumentsModalContent') private userDocumentsModalContent;
  openUserDocumentsModal() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "animate__animated animate__slideInUp animate__faster",
      backdrop: 'static',
      keyboard: false
    }
    this.modalService.open(this.userDocumentsModalContent, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed`;
    });
  };

  userViewDocumentList;
  userId = null;
  onViewUserDocumentsClick(formObj) {
    this.userId = formObj.userId
    this.humanResourceService.getUserDocuments(formObj.userId)
      .subscribe(
        resp => {
          this.userViewDocumentList = resp;
          console.log('resp', resp);
          this.openUserDocumentsModal();
        },
        error => {
          // console.log(error);
        }
      )
  };

  onDocDelete(doc) {
    Swal.fire({
      text: 'Are you sure you want to Delete?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalStatus = 'delete';
        this.humanResourceService.deleteDoc(doc.id)
          .subscribe(resp => { })
        this.closeModal();
        this.commonMessageService.swalAlertWithIcon('', 'Deleted Successfully!', 'success');
      }
    })
  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.employeeFormErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.employeeFormSubmitted) {
          const messages = this.employeeFormValidationMessages[key];
          if (!messages) {
            console.warn("Validation messages for  are undefined.", key);
            return; // Prevent further processing
          }

          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              console.log('logValidationErrors', this.employeeFormErrors[key]);
              this.employeeFormErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  logValidationErrorsForCtc(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      const control = this.ctcForm.get(key);
      if (control && control.invalid) {
        console.log(`❌ Invalid control BEFORE logger: ${key}`, control.errors);
      }
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrorsForCtc(abstractControl);
      } else {
        this.ctcFormErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.ctcFormSubmitted) {
          const messages = this.ctcFormValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              console.log('errorKey', abstractControl);
              this.ctcFormErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  formatFromDate(fromDate) {
    console.log('from date', fromDate);
    var entryDate1 = new Date(
      fromDate.year +
      '/' +
      fromDate.month +
      '/' +
      fromDate.day
    );
    var formatDate = moment(entryDate1).format('DD/MM/YYYY');
    console.log('format date', formatDate);
    return formatDate;

  }

  minToCtcDate;
  getMinToDateCtc() {
    this.minToCtcDate = null
    console.log("fromDate", this.ctcForm.value.fromDate)
    this.minToCtcDate = this.ctcForm.value.fromDate
  }

  profileStatusSelect() {
    if (this.employeeForm.value.userExitDetails == null || this.employeeForm.value.userExitDetails.exitDate == null) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please add exit date before closing the profile');
      this.employeeForm.patchValue({
        profileStatus: true
      })
    }
  }

  getUserCTCFromDate(userCTCDetails) {
    if (this.modalStatus == 'edit' && !this.showCTCFromDate) {
      var newFromDate = new Date(userCTCDetails.value.fromDate.year + '/' + userCTCDetails.value.fromDate.month + '/' + userCTCDetails.value.fromDate.day);
      var formatFromDate = moment(newFromDate).format('DD/MM/YYYY');
      return formatFromDate;
    } else {
      return moment(userCTCDetails.value.fromDate).format('DD/MM/YYYY');
    }
  }

  getUserCTCToDate(userCTCDetails) {
    if (this.modalStatus == 'edit' && !this.showCTCFromDate) {
      var newToDate = new Date(userCTCDetails.value.toDate.year + '/' + userCTCDetails.value.toDate.month + '/' + userCTCDetails.value.toDate.day);
      var formatToDate = moment(newToDate).format('DD/MM/YYYY');
      return formatToDate;
    } else {
      return moment(userCTCDetails.value.toDate).format('DD/MM/YYYY');
    }
  }

  viewCurrentReportPartner(reportingPartner) {
    var name = '';
    reportingPartner.map((resp: any) => {
      var startDateYear = new Date(resp.startDate).getFullYear();
      var currentDateYear = new Date().getFullYear();
      if (startDateYear >= currentDateYear) {
        name = resp.reportingPartner.firstName + " " + resp.reportingPartner.lastName;
      } else {
        name = resp.reportingPartner.firstName + " " + resp.reportingPartner.lastName;
      }
    })
    return name;
  }

  onSameAsPermanentToggle(): void {
    const isChecked = this.employeeForm.get('sameAsPermanent')?.value;
    const permanentAddress = this.employeeForm.get('permanentAddress')?.value;

    if (isChecked) {

      this.localCityList = this.permanentCityList;
      this.localPostcodeList = this.permanentPostcodeList;

      this.employeeForm.controls['localAddress']?.patchValue({
        address: permanentAddress.address,
        streetName: permanentAddress.streetName,
        state: permanentAddress.state,
        city: permanentAddress.city,
        postalCode: permanentAddress.postalCode,
        country: permanentAddress.country,
        type: "local"
      });

      this.employeeForm.controls['localAddress']?.disable();
    } else {
      if (this.modalStatus == 'edit' && this.isSameAddress == false) {
        this.employeeForm.controls['localAddress']?.patchValue({
          address: this.oldLocalAddress.address,
          streetName: this.oldLocalAddress.streetName,
          state: this.oldLocalAddress.state,
          city: this.oldLocalAddress.city,
          postalCode: this.oldLocalAddress.postalCode,
          country: this.oldLocalAddress.country,
          type: "local"
        });

      } else {
        this.employeeForm.controls['localAddress']?.enable();
        this.employeeForm.controls['localAddress']?.reset({
          address: '',
          streetName: '',
          city: null,
          state: null,
          postalCode: null,
          country: '',
          type: "local"
        });
      }
    }
  }


  uncheckAddressCheckbox() {
    this.employeeForm.get('sameAsPermanent')?.setValue(false, { emitEvent: false });
    this.employeeForm.get('localAddress').reset({
      address: '',
      streetName: '',
      city: null,
      state: null,
      postalCode: null,
      country: '',
    });
  }

  ctcSubscription?: Subscription;
  isPf: boolean;
  listenToCtcChangesForPfApplicable() {

    this.ctcSubscription = this.ctcForm.get('ctc')?.valueChanges.subscribe(ctc => {

      const epf1 = this.ctcForm.get('epfApplicable')?.value;
      const designation = this.ctcForm.get('designation')?.value;
      let adjustedCtc;

      if (Number(designation) === 1 || Number(designation) === 10) {
        var variableComponent = 0;
        const variableComponentPercent = this.ctcForm.get('variableComponentPercent')?.value || 0;
        if (variableComponentPercent > 0) {
          variableComponent = (((ctc - epf1 - (this.ctcForm.get('esic')?.value || 0))) * variableComponentPercent) / 100;
        }
        this.ctcForm.patchValue({
          basic: ctc,
          hra: 0,
          conveyanceAllowance: 0,
          medicalAllowance: 0,
          esic: 0,
          providentFund: 0,
          variableComponent: variableComponent,
          securityDeposit: 0
        }, { emitEvent: false });
        return;
      };

      if (ctc && (epf1 === null || epf1 === undefined)) {

        Swal.fire({
          text: 'Please select EPF Applicable status first',
          confirmButtonText: 'Ok',
          confirmButtonColor: '#800000'
        });

        this.ctcForm.patchValue({
          ctc: null
        }, { emitEvent: false });
        return;

      }

      // if (!ctc && designation === 1) return;

      this.isPf = this.ctcForm.get('epfApplicable')?.value; // always get latest PF value

      let basic = 0;
      let epf = 0;
      let esic = 0;
      let hra = 0;
      let conveyance = 0;
      let otherAllowances = 0;

      // adjustedCtc = ctc > 23482.5
      //   ? ctc - 1800
      //   : (ctc > 17287.5
      //     ? (ctc - 1800) / 1.0325
      //     : ctc / 1.1525);
      // adjustedCtc =
      //   (ctc - 1800) > 21000
      //     ? (ctc - 1800)
      //     : (ctc - 1800) / 1.0325;
      const baseCtc = ctc - 1800;
      const adjustedBase = baseCtc / 1.0325;

      //  adjustedCtc =
      //   baseCtc >= 21001 && baseCtc <= 21500
      //     ? baseCtc
      //     : adjustedBase >= 15000 && adjustedBase <= 21000
      //       ? adjustedBase
      //       : baseCtc > 21500
      //         ? baseCtc
      //         : ctc / 1.1525;
      adjustedCtc =
        ctc <= 0
          ? ""
          : Math.round(
            ctc <= 17287.5
              ? ctc / 1.1525
              : ctc <= 23482.5
                ? (ctc - 1800) / 1.0325
                : ctc < 24080
                  ? ctc - 1800
                  : ctc <= 45580
                    ? ctc - 2580
                    : ctc <= 53000
                      ? ctc / 1.06
                      : ctc - 3000
          );
      console.log("adjustedCtc", adjustedCtc);
      if (this.isPf) {

        // const ctcDiv112 = ctc / 1.12;

        // if (ctcDiv112 <= 15000) basic = ctc / 1.1575;
        // else if (ctcDiv112 <= 21500 && ctc / 1.0375 <= 21000) basic = (ctc - 1800) / 1.0375;
        // else if (ctc / 2 < 21500) basic = 21500;
        // else basic = ctc / 2;

        // basic = Math.min(ctc, basic);


        // Equivalent of Excel formula


        const adjustedDiv112 = adjustedCtc / 1.12;

        // if (adjustedDiv112 <= 15000) {
        //     basic = adjustedCtc / 1.1575;
        // } else if (
        //     adjustedDiv112 <= 21500 &&
        //     adjustedCtc / 1.0375 <= 21000
        // ) {
        //     basic = (adjustedCtc - 1800) / 1.0375;
        // } else if (adjustedCtc / 2 < 21500) {
        //     basic = 21500;
        // } else {
        //     basic = adjustedCtc / 2;
        // }


        // basic =
        //   (adjustedCtc < 15000) ? adjustedCtc :
        //     (adjustedCtc < 21500) ? 15000 :
        //       (adjustedCtc <= 43000) ? 21500 :
        //         adjustedCtc * 0.5;
        basic =
          adjustedCtc <= 15000
            ? adjustedCtc
            : adjustedCtc <= 21500
              ? 15000
              : adjustedCtc <= 43000
                ? 21500
                : adjustedCtc * 0.5;

        basic = Math.min(adjustedCtc, basic);

        // epf = basic <= 15000 ? basic * 0.12 : 1800;
        epf = Math.min(basic, 25000) * 0.12;
        esic = adjustedCtc <= 21000 ? adjustedCtc * 0.0325 : 0;

        // hra = Math.max(0, adjustedCtc <= 21500 ? 0 : adjustedCtc <= 43000 ? (adjustedCtc - 21500) * 0.75
        //   : adjustedCtc * 0.3
        // );
        // hra =
        //   (adjustedCtc < 15000) ? 0 :
        //     (adjustedCtc < 21500) ? (adjustedCtc - 15000) :
        //       Math.min(adjustedCtc * 0.35, adjustedCtc - basic);
        hra = Math.min(
          Math.max(adjustedCtc - basic, 0),
          adjustedCtc * 0.35
        );

        // conveyance = (adjustedCtc <= 21500)
        //   ? 0
        //   : Math.max(
        //     0,
        //     Math.min(adjustedCtc * 0.10, adjustedCtc - basic - hra)
        //   );
        conveyance = Math.min(
          Math.max(adjustedCtc - basic - hra, 0),
          adjustedCtc * 0.10
        );

        // otherAllowances = Math.max(0, adjustedCtc - basic - hra - conveyance);
        otherAllowances = Math.max(
          adjustedCtc - basic - hra - conveyance,
          0
        );

      } else {

        // if (ctc / 1.0375 <= 21000) basic = ctc / 1.0375;
        // else if (ctc / 2 < 21500) basic = 21500;
        // else basic = ctc / 2;
        basic =
          (ctc < 15000) ? ctc :
            (ctc < 21500) ? 15000 :
              (ctc <= 43000) ? 21500 :
                ctc * 0.5;

        basic = Math.min(ctc, basic);

        esic = ctc <= 21000 ? ctc * 0.0325 : 0;

        // hra = Math.max(0, Math.min(ctc - basic - epf - esic, ctc * 0.35));
        hra =
          (ctc < 15000) ? 0 :
            (ctc < 21500) ? (ctc - 15000) :
              Math.min(ctc * 0.35, ctc - basic);

        // conveyance = Math.max(
        //   0,
        //   Math.min(ctc - basic - hra - epf - esic, ctc * 0.10)
        // );
        conveyance = (ctc <= 21500)
          ? 0
          : Math.max(
            0,
            Math.min(ctc * 0.10, ctc - basic - hra)
          );

        otherAllowances = Math.max(
          0,
          ctc - (basic + hra + conveyance)
        );
      }

      // const hra = Math.max(0, Math.min(ctc - basic - epf - esic, ctc * 0.35));
      //       const hra = Math.max( 0,adjustedCtc <= 21500 ? 0 : adjustedCtc <= 43000 ? (adjustedCtc - 21500) * 0.75
      //       : adjustedCtc * 0.3
      // );

      // const conveyance = Math.max(
      //   0,
      //   Math.min(ctc - basic - hra - epf - esic, ctc * 0.10)
      // );
      //     const conveyance =
      // adjustedCtc <= 21500
      //   ? 0
      //   : adjustedCtc <= 43000
      //   ? Math.max(0, (adjustedCtc - 21500) * 0.25)
      //   : adjustedCtc * 0.1;

      // const otherAllowances = Math.max(
      //   0,
      //   ctc - (basic + hra + conveyance + epf + esic)
      // );
      // const otherAllowances = Math.max( 0, adjustedCtc - basic - conveyance - hra);

      var securityDeposit = 0;
      if (this.employeeForm.get('probabtionPeriod')?.value > 0) {
        securityDeposit = ((ctc - epf - esic) * 5) / 100;
      } else {
        securityDeposit = 0;
      }

      var variableComponent = 0;
      const variableComponentPercent = this.ctcForm.get('variableComponentPercent')?.value || 0;
      if (variableComponentPercent > 0) {
        variableComponent = (((ctc - epf - esic) * 12) * variableComponentPercent) / 100;
      }

      this.ctcForm.patchValue({
        basic: Math.round(basic),
        variableComponent: Math.round(variableComponent),
        securityDeposit: Math.round(securityDeposit),
        providentFund: Math.round(epf),
        esic: Math.round(esic),
        hra: Math.round(hra),
        conveyanceAllowance: Math.round(conveyance),
        medicalAllowance: Math.round(otherAllowances)
      }, { emitEvent: false });

    });

  }

  // listenToCtcInput() {
  //   this.ctcForm.get('ctc')?.valueChanges.subscribe(ctc => {

  //     const epf = this.ctcForm.get('epfApplicable')?.value;

  //     if (ctc && (epf === null || epf === undefined)) {

  //       Swal.fire({
  //         text: 'Please select EPF Applicable status first',
  //         confirmButtonText: 'Ok',
  //         confirmButtonColor: '#800000'
  //       });

  //       this.ctcForm.patchValue({
  //         ctc: null
  //       }, { emitEvent: false });

  //     }

  //   });
  // }

  onEpfApplicableChange() {
    const epf = this.ctcForm.get('epfApplicable')?.value;
    const pfControl = this.ctcForm.get('providentFund');
    const uanControl = this.ctcForm.get('uanNo');

    const preservedValues = {
      designation: this.ctcForm.get('designation')?.value,
      overtimeApplicability: this.ctcForm.get('overtimeApplicability')?.value,
      laptopEligibility: this.ctcForm.get('laptopEligibility')?.value,
      professionalExceptionMonth: this.ctcForm.get('professionalExceptionMonth')?.value,
      professionalExceptionTax: this.ctcForm.get('professionalExceptionTax')?.value,
      securityFromDate: this.ctcForm.get('securityFromDate')?.value,
      securityToDate: this.ctcForm.get('securityToDate')?.value,
      uanNo: this.ctcForm.get('uanNo')?.value,
      providentFund: 0,
      professionalTax: this.ctcForm.get('professionalTax')?.value,
      exgratiaMonth: this.ctcForm.get('exgratiaMonth')?.value || '',
      exgratia: this.ctcForm.get('exgratia')?.value || 0,
      variableComponentPercent: this.ctcForm.get('variableComponentPercent')?.value || 0,
      loan: this.ctcForm.get('loan')?.value || 0,
      emi: this.ctcForm.get('emi')?.value || 0,
      advance: this.ctcForm.get('advance')?.value || 0,
      advanceMonth: this.ctcForm.get('advanceMonth')?.value || '',
      recoveryOrExpenses: this.ctcForm.get('recoveryOrExpenses')?.value || 0,
      recoveryMonth: this.ctcForm.get('recoveryMonth')?.value || '',
    };

    epf ? pfControl?.enable() : pfControl?.disable();

    this.ctcForm.reset();

    this.ctcForm.patchValue({
      epfApplicable: epf,
      ...preservedValues
    });

    if (epf) {
      uanControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d{12}$/)
      ]);
    } else {
      uanControl?.clearValidators();
    }
    uanControl?.updateValueAndValidity();

  }

  validateUanNumber() {
    const uanValue = String(this.ctcForm.get('uanNo')?.value || '');
    const epf = this.ctcForm.get('epfApplicable')?.value;
    if (epf) {
      if (!/^\d{12}$/.test(uanValue)) {
        this.ctcForm.get('uanNo')?.setErrors({ pattern: true });
        this.commonMessageService.swalAlertWithoutIcon('', 'UAN number must be a 12-digit numeric value');
      } else {
        this.ctcForm.get('uanNo')?.setErrors(null);
      }
    }

  }


  initializeCtcFormChangeSubscription() {

    // this.ctcForm.get('epfApplicable')?.valueChanges.subscribe(epf => {
    //   const pfControl = this.ctcForm.get('providentFund');

    //   epf ? pfControl?.enable() : pfControl?.disable();
    // });

    const from = this.ctcForm.get('loanFromDate');
    const to = this.ctcForm.get('loanToDate');

    from?.clearValidators();
    to?.clearValidators();

    from?.updateValueAndValidity();
    to?.updateValueAndValidity();
    this.ctcForm.get('loanFromDate')?.valueChanges.subscribe((fromDate) => {
      const toDateControl = this.ctcForm.get('loanToDate');
      if (fromDate) {
        const toDate = this.calculateLoanToDate(fromDate);
        toDateControl?.setValue(toDate);
      } else {
        toDateControl?.setValue(null);
      }
    });

    this.ctcForm.get('variableComponentPercent')?.valueChanges.subscribe((variableComponentPercent) => {
      const percent = Number(variableComponentPercent);
      if (percent > 0) {
        const ctc = this.ctcForm.get('ctc')?.value || 0;
        console.log('CTC value', ctc);
        const variableComponent = (((ctc - (this.ctcForm.get('providentFund')?.value || 0) - (this.ctcForm.get('esic')?.value || 0)) * 12) * percent) / 100;
        this.ctcForm.get('variableComponent')?.setValue(variableComponent);
      } else {
        this.ctcForm.get('variableComponent')?.setValue(0);
      }
    });
  }

  getTotalAmount(userCtcDetail: any): number {
    let fromDate: Date;

    if (typeof userCtcDetail?.fromDate === 'string') {
      fromDate = new Date(userCtcDetail.fromDate);
    } else {
      const dateObj = userCtcDetail?.fromDate;
      fromDate = new Date(
        dateObj.year,
        dateObj.month - 1,
        dateObj.day
      );
    }

    // for new salary wages implemented from April 1, 2026
    const aprilFirst2026 = new Date(2026, 3, 1);
    const providentFund =
      fromDate.getTime() >= aprilFirst2026.getTime()
        ? (userCtcDetail?.providentFund || 0)
        : 0;

    return (
      (userCtcDetail?.basic || 0) +
      (userCtcDetail?.childHostelAllowance || 0) +
      (userCtcDetail?.conveyanceAllowance || 0) +
      (userCtcDetail?.hra || 0) +
      (userCtcDetail?.medicalAllowance || 0) +
      (userCtcDetail?.esic || 0) +
      providentFund +
      (userCtcDetail?.mobileAllowance || 0)
    );
  }
}
